import {
  useMemo,
  useState,
  useCallback,
  useEffect,
  useContext,
  useRef,
} from "react";
import { useTitanApp } from "@/hooks/useTitanApp";
import { AppointmentVaccine } from "./schedule/BookingModal"; // type for vaccine entries
import { v4 as uuidv4 } from "uuid";
import { parse, addMinutes } from "date-fns";
import {
  addScheduleEvent,
  deleteScheduleEvents,
  addBlockOut,
  getUsrAvailibility,
  getUsersAvailabilityByPriority,
  deleteBlockOut,
  setShowBacktoSlotsButton,
  setBookingSlotsMode,
  addBlockOutAndRefresh,
  refreshMyAppointmentsSilently,
  refreshScheduleEventsSilently,
} from "../../dispatchers/scheduleEventsDispatchers";
import {
  getRoomsForAppointment,
  setAppointmentRooms,
  setShowNHS111ReferralTab,
  getPharmacyAvailableSlots,
  getActivePharmacists,
  getClinicalServicebyServiceCompanyId,
  getUsersByServiceCompanyPharmacyID,
  getAvailablePharmacistsForService,
} from "../../dispatchers/pharmacyServiceDispatchers";
import {
  setPatientInfoTab,
  setisPatientSearched,
  setCurrentGlobalTabValue,
  setCurrentGlobalTabText,
  setRoutedFromScheduler,
} from "@/dispatchers/appDispatchers";
import {
  getPatientConsultations,
  getPatientByPatientId,
  checkAndAddConsultation,
  getPatientConsultationByConsultationId,
  setPreConsultationTemplate,
  setPreConsultationTranscription,
  getPreConsultationByConsultationId,
  getPaymentAuditByConsultation,
  setPatientTabSwitcher,
  updateConsultationActions,
  setAddPatientAIChatMessage,
  setAiChatSuccessMessages,
  setBookingDetails,
  setIncrementBookingCompleted,
  trackServiceBilling,
  getPatientAppointmentsByPatientId,
  updateEventStatus,
  updateConsultationStatus,
  SaveAIChatMessage,
} from "@/dispatchers/patientDispatchers";
import { setIsTemplateSelected } from "@/dispatchers/templateDispatchers";
import { ActionType } from "@/enum/ActionType";
import { useNavigate, useLocation } from "react-router";
import { ScheduleContext } from "./ScheduleContext";
import removeActionFromLocal from "@/utils/removeFromLocalStorage.js";
import { NumberIsUKFormat } from "@/utils/validMobile";
import { format } from "date-fns";
import { hasAccessOn } from "@/utils/accessDates";

// Original interfaces (keeping unchanged as requested)
export interface Booking {
  id: string;
  consultationID?: string;
  patientName: string;
  pharmacist: string;
  pharmacistId?: string;
  resourceId?: string;
  serviceType: "Earwax" | "Travel" | "Weight" | "Covid";
  serviceName: string; // Actual service name from API
  serviceId: string; // Service ID for color mapping
  date: string;
  time: string;
  duration: number; // in minutes
  room?: string; // Room display name
  roomId?: string; // Room identifier
  notes?: string;
  status?: "confirmed" | "pending" | "cancelled" | "completed";
  contactNumber?: string;
  email?: string;
  confirmationMethod?: "email" | "mobile";
  patientId?: string;
  eventStatus?: number; // Event status from API (1 = disable actions, etc.)
  isOtherPharmacy?: boolean;
  otherPharmacyName?: string;
  pharmacyId?: string;
  otherPharmacyId?: string;
  serviceColor?: string;
  isMyAppointments?: boolean;
  // optional lists from BookingModal
  tasksToComplete?: any[];
  vaccinesAdminister?: AppointmentVaccine[];
  appointmentType?: number;
}

export const timeSlots = [
  "08:00",
  "08:30",
  "09:00",
  "09:30",
  "10:00",
  "10:30",
  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
  "14:00",
  "14:30",
  "15:00",
  "15:30",
  "16:00",
  "16:30",
  "17:00",
  "17:30",
];

export const pharmacists = [
  "Ayesha Khan",
  "Bilal Ahmed",
  "Fatima Malik",
  "Hassan Ali",
  "Zainab Hussain",
  "Imran Sheikh",
];

export const mockRooms = [
  {
    id: "r1",
    name: "Consultation Room 1",
    services: ["Ear Wax Removal", "Flu Vaccination", "Men's Health"],
    availability: {
      monday: { enabled: true, timeBlocks: [{ from: "09:00", to: "17:00" }] },
      tuesday: { enabled: true, timeBlocks: [{ from: "09:00", to: "17:00" }] },
      wednesday: {
        enabled: true,
        timeBlocks: [{ from: "09:00", to: "17:00" }],
      },
      thursday: { enabled: true, timeBlocks: [{ from: "09:00", to: "17:00" }] },
      friday: { enabled: true, timeBlocks: [{ from: "09:00", to: "17:00" }] },
      saturday: { enabled: false, timeBlocks: [] },
      sunday: { enabled: false, timeBlocks: [] },
    },
    active: true,
  },
  {
    id: "r2",
    name: "Private Room A",
    services: ["Travel Health", "Men's Health"],
    availability: {
      monday: { enabled: true, timeBlocks: [{ from: "10:00", to: "16:00" }] },
      tuesday: { enabled: true, timeBlocks: [{ from: "10:00", to: "16:00" }] },
      wednesday: {
        enabled: true,
        timeBlocks: [{ from: "10:00", to: "16:00" }],
      },
      thursday: { enabled: true, timeBlocks: [{ from: "10:00", to: "16:00" }] },
      friday: { enabled: true, timeBlocks: [{ from: "10:00", to: "16:00" }] },
      saturday: { enabled: true, timeBlocks: [{ from: "09:00", to: "13:00" }] },
      sunday: { enabled: false, timeBlocks: [] },
    },
    active: true,
  },
  {
    id: "r3",
    name: "Treatment Room B",
    services: ["Ear Wax Removal", "Flu Vaccination"],
    availability: {
      monday: { enabled: true, timeBlocks: [{ from: "08:00", to: "18:00" }] },
      tuesday: { enabled: true, timeBlocks: [{ from: "08:00", to: "18:00" }] },
      wednesday: {
        enabled: true,
        timeBlocks: [{ from: "08:00", to: "18:00" }],
      },
      thursday: { enabled: true, timeBlocks: [{ from: "08:00", to: "18:00" }] },
      friday: { enabled: true, timeBlocks: [{ from: "08:00", to: "18:00" }] },
      saturday: { enabled: false, timeBlocks: [] },
      sunday: { enabled: false, timeBlocks: [] },
    },
    active: true,
  },
  {
    id: "r4",
    name: "Multi-Purpose Room",
    services: [
      "Ear Wax Removal",
      "Travel Health",
      "Men's Health",
      "Flu Vaccination",
    ],
    availability: {
      monday: { enabled: true, timeBlocks: [{ from: "09:00", to: "17:00" }] },
      tuesday: { enabled: true, timeBlocks: [{ from: "09:00", to: "17:00" }] },
      wednesday: {
        enabled: true,
        timeBlocks: [{ from: "09:00", to: "17:00" }],
      },
      thursday: { enabled: true, timeBlocks: [{ from: "09:00", to: "17:00" }] },
      friday: { enabled: true, timeBlocks: [{ from: "09:00", to: "17:00" }] },
      saturday: { enabled: true, timeBlocks: [{ from: "10:00", to: "14:00" }] },
      sunday: { enabled: false, timeBlocks: [] },
    },
    active: true,
  },
];

export interface BlockOut {
  id: string;
  title: string;
  type: "team_event" | "training" | "maintenance" | "break" | "other";
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  description?: string;
  affectedRooms?: string[]; // Which rooms are blocked
  affectedPharmacists?: string[]; // Which pharmacists are unavailable
  otherPharmacyId?: string;
  isRecurring?: boolean;
  recurringPattern?: "daily" | "weekly" | "monthly";
  color?: string;
}

export const myAppointmentsList = [
  {
    _id: "699f23c5432ec09e3fafde01",
    ResourceType: 1,
    PharmacyID: "f1736418-4a0e-4342-b9ad-7e941317a61b",
    ResourceId: "ashhad.saud1992@gmail.com",
    CreatedAt: "2025-10-06T16:21:21.193Z",
    CalenderName: "Ashhad Saud",
    EventId: "c3a66a08-6973-4526-b3b0-db9862a46dbe",
    StartDate: "2026-04-01T09:00:00Z",
    EndDate: "2026-04-01T09:30:00Z",
    Duration: 30,
    Name: "General Consultation",
    ExceptionDates: [],
    ClinicalServiceID: "6942a876bc3c58170e53b719",
    AllDay: false,
    ScheduleEventType: 1,
    ServiceID: "68e7db7e63195cb19c87c362",
    PatientID: "28e76b39-654b-463a-8e09-a9f2e2648f73",
    Email: "ashhadsaud@hotmail.com",
    ConfirmationMethod: "email",
    ConsultationID: "c3a66a08-6973-4526-b3b0-db9862a46dbe",
  },
  {
    _id: "699f23c5432ec09e3fafde02",
    ResourceType: 1,
    PharmacyID: "f1736418-4a0e-4342-b9ad-7e941317a61b",
    ResourceId: "ashhad.saud1992@gmail.com",
    CreatedAt: "2025-10-06T16:21:21.193Z",
    CalenderName: "Ashhad Saud",
    EventId: "96a4617e-9672-4721-96e7-7cd96ffda61d",
    StartDate: "2026-04-02T10:00:00Z",
    EndDate: "2026-04-02T10:30:00Z",
    Duration: 30,
    Name: "Follow-up Visit",
    ExceptionDates: [],
    ClinicalServiceID: "6942ab1c1e30ddf33a3fbfd7",
    AllDay: false,
    ScheduleEventType: 1,
    ServiceID: "68e7db7e63195cb19c87c362",
    PatientID: "e91743f0-a7de-48b0-a4d7-df876209ab78",
    Email: "ashhadsaud@hotmail.com",
    ConfirmationMethod: "email",
    ConsultationID: "96a4617e-9672-4721-96e7-7cd96ffda61d",
  },
];

// Room interface matching settings structure
interface Room {
  id: string;
  name: string;
  services: string[];
  availability: {
    monday: { enabled: boolean; timeBlocks: { from: string; to: string }[] };
    tuesday: { enabled: boolean; timeBlocks: { from: string; to: string }[] };
    wednesday: { enabled: boolean; timeBlocks: { from: string; to: string }[] };
    thursday: { enabled: boolean; timeBlocks: { from: string; to: string }[] };
    friday: { enabled: boolean; timeBlocks: { from: string; to: string }[] };
    saturday: { enabled: boolean; timeBlocks: { from: string; to: string }[] };
    sunday: { enabled: boolean; timeBlocks: { from: string; to: string }[] };
  };
  active: boolean;
}

// Pharmacist object interface
export interface PharmacistProfile {
  id: string;
  name: string;
  avatar?: string;
  initials: string;
  specialty?: string;
  email?: string;
  role?: string;
  isAlreadyBooked?: boolean;
  isOutsideWorkingHours?: boolean;
}

// Room object interface
interface RoomProfile {
  id: string;
  name: string;
  avatar?: string;
  initials: string;
  type?: string;
  services?: string[];
}

// API Data Interfaces

interface APIScheduleEvent {
  _id: string;
  ResourceType: number;
  PharmacyID: string;
  ResourceId: string;
  CreatedAt: string;
  CalenderName: string;
  EventId: string;
  StartDate: string;
  EndDate: string;
  Duration?: number;
  DurationUnit: string;
  Name: string;
  PatientName?: string;
  ClinicalServiceID: string;
  AllDay: boolean;
  ScheduleEventType: number;
  ServiceID: string;
  PatientID?: string;
  EventStatus?: number;
  ConsultationID?: string;
  RoomId?: string;
  ConfirmationMethod?: string;
  Email?: string;
  AppointmentType?: number;
}
enum DraftStatus {
  Pending = "pending",
  Completed = "completed",
}

export const createVaccineDraftFromSchedule = async (
  vaccines: any[],
  consultationID: string,
) => {
  const draftData = {
    vaccineItems: vaccines.map((v) => ({
      vaccineName: v.vaccineName,
      dose: v.dose,
      schedule: v.schedule || "As per schedule",
      notes: v.notes,
      route: v.route || "IM / SC",
      site: v.site || "Deltoid - left / right",
    })),
    timestamp: new Date().toISOString(),
  };

  const payload = {
    payload: JSON.stringify(draftData),
    actionName: "CreateVaccineDraft",
    actionNumber: "12",
    isPerformed: true,
    performedAt: new Date().toISOString(),
    draftStatus: DraftStatus.Pending,
  };

  await updateConsultationActions({
    consultationId: consultationID,
    payload,
  });

  return {
    sender: "success",
    message: "Vaccine draft created.",
    actionId: 12,
    details: payload,
  };
};

export const createTaskDraftFromSchedule = async (
  tasks: any[],
  consultationID: string,
) => {
  const draftData = {
    tasks: tasks.map((t) => ({
      label: t,
      completed: false,
    })),
    timestamp: new Date().toLocaleString(),
  };

  const payload = {
    payload: JSON.stringify(draftData),
    actionName: "CreateTask",
    actionNumber: "14",
    isPerformed: true,
    performedAt: new Date().toLocaleString(),
    draftStatus: DraftStatus.Pending,
  };

  await updateConsultationActions({
    consultationId: consultationID,
    payload,
  });

  return {
    sender: "success",
    message: "Task created.",
    actionId: 14,
    details: payload,
  };
};
interface APIResource {
  id: string;
  name: string;
  resourceType: number;
  services: {
    _id: string;
    serviceName: string;
    serviceType: number;
    serviceDuration: number;
    availability?:
      | {
          dayOfWeek: number;
          slots: { startTime: string; endTime: string }[];
        }[]
      | null;
  }[];
  role: {
    _id: string;
    roleName: string;
    companyId: string;
    isAdmin: boolean;
    roleType?: number;
    permissions: string[];
  };
}

interface APIService {
  _id: string;
  name?: string; // returned directly from API (matches JSON `name` field)
  label?: string; // alias label in API response
  serviceName: string;
  serviceType: number;
  serviceColor: string;
  serviceCharges: number;
  serviceDuration: number;
  isDefault: boolean;
  companyID: string | null;
  serviceDescription: string;
  notificationTemplates: any[];
  serviceCode: number;
  isOnlineBooking: boolean;
  availability:
    | {
        dayOfWeek: number;
        slots: { startTime: string; endTime: string }[];
      }[]
    | null;
  isRoomRequired: boolean;
}

interface UserWeekAvailability {
  dayOfWeek: DayOfWeek; // 0–6 (Sunday–Saturday)
  slots: UserTimeSlot[];
}

interface UserTimeSlot {
  startTime?: string | null; // nullable in C#
  endTime?: string | null; // nullable in C#
}

// If you want to match C# DayOfWeek enum:
enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

interface ValidationResult {
  isValid: boolean;
  message?: string;
}

// Service type mapping (you can adjust these based on your actual service mappings)
const SERVICE_TYPE_MAPPING: {
  [key: string]: "Earwax" | "Travel" | "Weight" | "Covid";
} = {
  "Ear Wax": "Earwax",
  "Travel Vaccine": "Travel",
  "New Medicine Service": "Weight",
  "General Service": "Covid",
  "samad service": "Covid",
};

// Block-out types and configuration
export const blockOutTypes = [
  { value: "team_event", label: "Team Event", color: "bg-indigo-500" },
  { value: "training", label: "Training Session", color: "bg-green-500" },
  { value: "maintenance", label: "Maintenance", color: "bg-yellow-500" },
  { value: "break", label: "Break/Lunch", color: "bg-gray-500" },
  { value: "other", label: "Other", color: "bg-purple-500" },
] as const;
const COLOR_POOL = [
  "yellow",
  "orange",
  "green",
  "purple",
  "blue",
  "red",
  "pink",
  "indigo",
  "teal",
  "cyan",
];

export const getColors = (
  serviceTypes: string[],
  isDarkMode: boolean,
): Record<string, string> => {
  const colorMap: Record<string, string> = {};

  serviceTypes.forEach((service, index) => {
    const color = COLOR_POOL[index % COLOR_POOL.length]; // loop if out of colors

    colorMap[service] = isDarkMode
      ? `bg-${color}-900 text-${color}-200`
      : `bg-${color}-100 text-${color}-800`;
  });

  return colorMap;
};

// Convert hex color to Tailwind color class
export const hexToTailwindColor = (hexColor: string): string => {
  if (!hexColor || hexColor === "") return "bg-gray-500";

  // Remove # if present
  const hex = hexColor.replace("#", "").toLowerCase();

  // Color mapping from hex to Tailwind classes
  const colorMap: { [key: string]: string } = {
    // Reds
    ff0000: "bg-red-500",
    dc2626: "bg-red-600",
    b91c1c: "bg-red-700",
    bd2b24: "bg-red-600", // Ear Wax color
    ef4444: "bg-red-500",

    // Blues
    "0000ff": "bg-blue-500",
    "2563eb": "bg-blue-600",
    "1d4ed8": "bg-blue-700",
    "2346de": "bg-blue-600", // Travel Vaccine color
    "3b82f6": "bg-blue-500", // samad service color

    // Yellows
    ffff00: "bg-yellow-500",
    eab308: "bg-yellow-500",
    f59e0b: "bg-yellow-500",
    fbbf24: "bg-yellow-400", // New Medicine Service color

    // Greens
    "00ff00": "bg-green-500",
    "16a34a": "bg-green-600",
    "15803d": "bg-green-700",
    "22c55e": "bg-green-500",

    // Purples
    "800080": "bg-purple-500",
    "7c3aed": "bg-purple-600",
    "6d28d9": "bg-purple-700",

    // Grays
    "000000": "bg-black",
    ffffff: "bg-white",
    "6b7280": "bg-gray-500",
    "9ca3af": "bg-gray-400",
    "4b5563": "bg-gray-600",

    // Orange
    f97316: "bg-orange-500",
    ea580c: "bg-orange-600",

    // Pink
    ec4899: "bg-pink-500",
    d946ef: "bg-fuchsia-500",

    // Teal
    "14b8a6": "bg-teal-500",
    "0d9488": "bg-teal-600",
  };

  // Direct match
  if (colorMap[hex]) {
    return colorMap[hex];
  }

  // Convert to RGB and find closest match
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  // Determine dominant color
  if (r > g && r > b) {
    return r > 200 ? "bg-red-400" : r > 150 ? "bg-red-500" : "bg-red-600";
  } else if (g > r && g > b) {
    return g > 200 ? "bg-green-400" : g > 150 ? "bg-green-500" : "bg-green-600";
  } else if (b > r && b > g) {
    return b > 200 ? "bg-blue-400" : b > 150 ? "bg-blue-500" : "bg-blue-600";
  } else if (r === g && g === b) {
    // Grayscale
    return r > 200 ? "bg-gray-300" : r > 150 ? "bg-gray-500" : "bg-gray-700";
  } else {
    // Mixed colors, default to gray
    return "bg-gray-500";
  }
};

// New function to get colors from service data
export const getColorsFromServiceData = (
  services: APIService[],
  isDarkMode: boolean,
): Record<string, { bg: string; text: string; color: string }> => {
  const colorMap: Record<
    string,
    { bg: string; text: string; color: string }
  > = {};

  services.forEach((service) => {
    const hexColor = service.serviceColor || "#6b7280"; // default gray if no color

    colorMap[service.serviceName] = {
      bg: hexColor,
      text: isDarkMode ? "#ffffff" : "#000000",
      color: hexColor,
    };
  });

  return colorMap;
};

// Service colors (exported so components can reuse if needed)
export const getServiceColors = (isDarkMode: boolean) => ({
  Earwax: isDarkMode
    ? "bg-yellow-900 text-yellow-200"
    : "bg-yellow-100 text-yellow-800",
  Travel: isDarkMode
    ? "bg-orange-900 text-orange-200"
    : "bg-orange-100 text-orange-800",
  Weight: isDarkMode
    ? "bg-green-900 text-green-200"
    : "bg-green-100 text-green-800",
  Covid: isDarkMode
    ? "bg-purple-900 text-purple-200"
    : "bg-purple-100 text-purple-800",
});

// Get service colors based on actual service data — returns hex colors directly
export const getServiceColorsFromData = (
  services: APIService[],
  isDarkMode: boolean,
): Record<string, string> => {
  const colorMap: Record<string, string> = {};

  services.forEach((service) => {
    if (service.serviceColor) {
      colorMap[service.name || service.serviceName] = service.serviceColor;
    }
  });

  return colorMap;
};

// Transformation functions
const getDateTimeParts = (dateStr: string) => {
  const d = new Date(dateStr);

  const year = d.getUTCFullYear();
  const month = d.getUTCMonth() + 1;
  const day = d.getUTCDate();
  const hours = d.getUTCHours();
  const minutes = d.getUTCMinutes();

  const date = `${year}-${String(month).padStart(2, "0")}-${String(
    day,
  ).padStart(2, "0")}`;
  const time = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0",
  )}`;

  return { date, time };
};

const transformAPIEventsToBookings = (
  scheduleEvents: APIScheduleEvent[],
  resources: APIResource[],
  services: APIService[],
  pharmacies: any[] = [],
  currentPharmacyId?: string,
): Booking[] => {
  const bookings: Booking[] = [];
  scheduleEvents.forEach((scheduleEvent) => {
    const resource = resources.find((r) => r.id === scheduleEvent.ResourceId);
    if (!resource) return;
    // Find the service info
    const service = services.find((s) => s._id === scheduleEvent.ServiceID);
    if (!service) return;
    // Map service name to our service type
    const serviceType = SERVICE_TYPE_MAPPING[service.serviceName] || "Covid";

    // Convert date/time (use local date to avoid timezone shifting issues)
    const { date, time } = getDateTimeParts(scheduleEvent.StartDate);

    // Calculate duration
    let duration = 15; // Changed default to 15 minutes
    if (scheduleEvent.StartDate && scheduleEvent.EndDate) {
      // Most reliable method - calculate from actual start and end times
      try {
        const start = new Date(scheduleEvent.StartDate);
        const end = new Date(scheduleEvent.EndDate);
        const diffInMinutes = (end.getTime() - start.getTime()) / (1000 * 60);
        if (diffInMinutes > 0) {
          duration = Math.round(diffInMinutes * 100) / 100; // Round to handle floating-point precision
        }
      } catch (error) {
        // Fall back to Duration field if date calculation fails
        if (scheduleEvent.Duration) {
          if (scheduleEvent.DurationUnit) {
            if (
              scheduleEvent.DurationUnit === "hour" ||
              scheduleEvent.DurationUnit === "h"
            ) {
              duration = scheduleEvent.Duration * 60;
            } else if (
              scheduleEvent.DurationUnit === "minute" ||
              scheduleEvent.DurationUnit === "m"
            ) {
              duration = scheduleEvent.Duration;
            }
          } else {
            // If no DurationUnit, assume minutes
            duration = scheduleEvent.Duration;
          }
        }
      }
    } else if (scheduleEvent.Duration) {
      // Fall back to Duration field if dates aren't available
      if (scheduleEvent.DurationUnit) {
        if (
          scheduleEvent.DurationUnit === "hour" ||
          scheduleEvent.DurationUnit === "h"
        ) {
          duration = scheduleEvent.Duration * 60;
        } else if (
          scheduleEvent.DurationUnit === "minute" ||
          scheduleEvent.DurationUnit === "m"
        ) {
          duration = scheduleEvent.Duration;
        }
      } else {
        // If no DurationUnit, assume minutes
        duration = scheduleEvent.Duration;
      }
    }

    // Determine if this is a pharmacist or room booking
    const isPharmacist = resource.resourceType === 1;
    const isRoom = resource.resourceType === 2;

    // Core fix: do not leave pharmacist blank when API already carries name fields.
    const eventAny = scheduleEvent as any;
    const resourceId = String(scheduleEvent.ResourceId || "").trim();
    const pharmacistResourceById = resources.find(
      (r) =>
        r.resourceType === 1 &&
        String(r.id || "")
          .trim()
          .toLowerCase() === resourceId.toLowerCase(),
    );

    const pharmacistName =
      eventAny.PharmacistName ||
      eventAny.pharmacistName ||
      scheduleEvent.CalenderName ||
      (isPharmacist ? resource.name : "") ||
      pharmacistResourceById?.name ||
      "";

    // Prefer event.RoomId if provided to resolve room
    const roomResource = scheduleEvent.RoomId
      ? resources.find((r) => String(r.id) === String(scheduleEvent.RoomId))
      : undefined;
    const rawPharmId =
      scheduleEvent.PharmacyID ||
      (scheduleEvent as any).otherPharmacyId ||
      (scheduleEvent as any).OtherPharmacyId;
    const isOtherPharm = Boolean(
      rawPharmId &&
        currentPharmacyId &&
        String(rawPharmId).trim() !== String(currentPharmacyId).trim(),
    );
    const otherPharmacyId = isOtherPharm ? rawPharmId : undefined;
    const otherPharmacyName = isOtherPharm
      ? (pharmacies || []).find(
          (p: any) =>
            String(p.teamPharmacyID) === String(otherPharmacyId) ||
            String(p.id) === String(otherPharmacyId),
        )?.teamPharmacyName || ""
      : undefined;

    const rawTasks =
      scheduleEvent.TasksToComplete ||
      (scheduleEvent as any).tasksToComplete ||
      [];
    const tasksToComplete = Array.isArray(rawTasks)
      ? rawTasks.map((t: any, idx: number) => {
          if (typeof t === "string") {
            return { id: String(idx + 1), label: t, text: t, completed: false };
          }
          return {
            id: t.id || t.Id || t._id || String(idx + 1),
            label: t.label || t.text || t.name || t.Name || String(t),
            text: t.text || t.label || t.name || t.Name || String(t),
            completed: Boolean(t.completed),
          };
        })
      : [];

    const rawVaccines =
      scheduleEvent.VaccinesAdminister ||
      (scheduleEvent as any).vaccinesAdminister ||
      (scheduleEvent as any).VaccinesToAdminister ||
      [];
    const vaccinesAdminister = Array.isArray(rawVaccines)
      ? rawVaccines.map((v: any, idx: number) => {
          if (typeof v === "string") {
            return { id: String(idx + 1), name: v, vaccineName: v, dose: "" };
          }
          const vName =
            v.VaccineName || v.vaccineName || v.Name || v.name || "Vaccine";
          return {
            id: v.Id || v.id || v._id || String(idx + 1),
            name: vName,
            vaccineName: vName,
            dose: v.Manufacturer || v.dose || "",
            manufacturer: v.Manufacturer || "",
            prescriptionItemId: v.PrescriptionItemId || "",
          };
        })
      : [];

    const booking: Booking = {
      id: scheduleEvent.EventId,
      consultationID: scheduleEvent.ConsultationID,
      patientName: scheduleEvent.PatientName || scheduleEvent.Name || "",
      pharmacist: pharmacistName,
      pharmacistId: resourceId || undefined,
      resourceId: resourceId || undefined,
      serviceType,
      serviceName: service.serviceName,
      serviceId: service._id,
      date,
      time,
      duration,
      room: roomResource
        ? roomResource.name
        : isRoom
        ? resource.name
        : undefined,
      roomId: roomResource ? roomResource.id : isRoom ? resource.id : undefined,
      status: "confirmed",
      contactNumber: "",
      email: scheduleEvent.Email,
      notes: scheduleEvent.Name,
      patientId: scheduleEvent.PatientID || undefined,
      eventStatus: scheduleEvent.EventStatus,
      pharmacyId: scheduleEvent.PharmacyID,
      otherPharmacyId: otherPharmacyId,
      otherPharmacyName: otherPharmacyName as any,
      tasksToComplete,
      vaccinesAdminister,
      vaccinesToAdminister: vaccinesAdminister,
      confirmationMethod: scheduleEvent.ConfirmationMethod,
      appointmentType: scheduleEvent.AppointmentType || null,
    };

    bookings.push(booking);
  });
  return bookings.sort((a, b) => {
    const dateCompare = a.date.localeCompare(b.date);
    if (dateCompare !== 0) return dateCompare;
    return a.time.localeCompare(b.time);
  });
};

// Map backend ScheduleEventType (number) to BlockOut type (string)
const mapEventTypeToBlockOutType = (eventType: number): BlockOut["type"] => {
  switch (eventType) {
    case 2:
      return "team_event";
    case 3:
      return "training";
    case 4:
      return "maintenance";
    case 5:
      return "break";
    default:
      return "other";
  }
};

// Get Tailwind color class for a given BlockOut type
const getColorForBlockOutType = (type: BlockOut["type"]): string => {
  const t = blockOutTypes.find((x) => x.value === type);
  return t?.color || "bg-gray-500";
};

// Transform API events into BlockOut entries, link affected staff/room from the resource group
const transformAPIEventsToBlockOuts = (
  scheduleEvents: APIScheduleEvent[],
  resources: APIResource[],
): BlockOut[] => {
  const blocks: BlockOut[] = [];

  scheduleEvents.forEach((scheduleEvent) => {
    // Block-outs are non-appointment entries (ScheduleEventType !== 1)
    if (scheduleEvent.ScheduleEventType === 1) return;

    const startParts = getDateTimeParts(scheduleEvent.StartDate);
    const endParts = getDateTimeParts(scheduleEvent.EndDate);
    const startDate = startParts.date;
    const endDate = endParts.date;
    const startTime = startParts.time;
    const endTime = endParts.time;

    const type = mapEventTypeToBlockOutType(
      Number(scheduleEvent.ScheduleEventType),
    );

    // Determine affected resources based on ResourceType
    let affectedRooms: string[] = [];
    let affectedPharmacists: string[] = [];

    // ResourceType: 1 = Pharmacist, 2 = Room
    if (scheduleEvent.ResourceType === 1) {
      // This is a block-out for a pharmacist
      // The ResourceId could be an email, name, or ID
      const pharmacistName =
        scheduleEvent.CalenderName || scheduleEvent.ResourceId;
      if (pharmacistName) {
        affectedPharmacists = [pharmacistName];
      }
    } else if (scheduleEvent.ResourceType === 2) {
      // This is a block-out for a room
      const roomName = scheduleEvent.CalenderName || scheduleEvent.ResourceId;
      if (roomName) {
        affectedRooms = [roomName];
      }
    } else {
      // Try to find the resource from the resources array (fallback)
      const groupResource = resources.find(
        (r) => r.id === scheduleEvent.ResourceId,
      );
      if (groupResource) {
        if (groupResource.resourceType === 1) {
          affectedPharmacists = [groupResource.name];
        } else if (groupResource.resourceType === 2) {
          affectedRooms = [groupResource.name];
        }
      }
    }

    // Check if this is a full-day block-out (time range covers entire day)
    const isFullDayBlock = startTime === "00:00" && endTime === "23:59";

    // For multi-day block-outs, adjust times
    let effectiveStartTime = startTime;
    let effectiveEndTime = endTime;

    // If start and end dates are different, this is a multi-day block-out
    if (startDate !== endDate) {
      if (!isFullDayBlock) {
        // For multi-day block-outs, we'll handle the time logic in the conflict detection
        // Keep original times for now
        effectiveStartTime = startTime;
        effectiveEndTime = endTime;
      }
    }

    const block: BlockOut = {
      id: scheduleEvent.EventId,
      title: scheduleEvent.Name,
      type,
      startDate,
      endDate,
      startTime: effectiveStartTime,
      endTime: effectiveEndTime,
      description: "",
      affectedRooms,
      affectedPharmacists,
      isRecurring: false,
      color: getColorForBlockOutType(type),
      otherPharmacyId: scheduleEvent.PharmacyID || undefined,
    };

    blocks.push(block);
  });

  // Group block-outs with the same EventId (since one block-out might have separate entries for room and pharmacist)
  const groupedBlocks = new Map<string, BlockOut>();

  blocks.forEach((block) => {
    const existing = groupedBlocks.get(block.id);
    if (existing) {
      // Merge affected resources
      existing.affectedRooms = [
        ...new Set([
          ...(existing.affectedRooms || []),
          ...(block.affectedRooms || []),
        ]),
      ];
      existing.affectedPharmacists = [
        ...new Set([
          ...(existing.affectedPharmacists || []),
          ...(block.affectedPharmacists || []),
        ]),
      ];

      // A multi-day block-out is stored as one row per day (per resource) on the
      // backend, all sharing this EventId. Widen the group's date range to span
      // every row instead of keeping only whichever row was processed first -
      // otherwise a 1-10 Nov block-out collapses back down to just its first day.
      if (block.startDate && block.startDate < existing.startDate) {
        existing.startDate = block.startDate;
      }
      if (block.endDate && block.endDate > existing.endDate) {
        existing.endDate = block.endDate;
      }
    } else {
      groupedBlocks.set(block.id, { ...block });
    }
  });

  const mergedBlocks = Array.from(groupedBlocks.values());

  // Sort for consistent rendering
  return mergedBlocks.sort((a, b) => {
    const dateCompare = a.startDate.localeCompare(b.startDate);
    if (dateCompare !== 0) return dateCompare;
    return a.startTime.localeCompare(b.startTime);
  });
};
const generateInitials = (name: string): string => {
  if (!name || name.trim() === "") return "NA";

  const words = name.trim().split(/\s+/);
  if (words.length === 1) {
    // Single word - take first two characters
    return words[0].substring(0, 2).toUpperCase();
  } else {
    // Multiple words - take first character of first two words
    return words
      .slice(0, 2)
      .map((word) => word.charAt(0))
      .join("")
      .toUpperCase();
  }
};

// Helper function to get pharmacist display data for UI
export const getPharmacistDisplayData = (pharmacist: PharmacistProfile) => {
  return {
    id: pharmacist.id,
    name: pharmacist.name,
    hasAvatar: !!pharmacist.avatar,
    avatar: pharmacist.avatar,
    initials: pharmacist.initials,
    specialty: pharmacist.specialty,
    email: pharmacist.email,
    roles: pharmacist.role,
  };
};

// Helper function to get avatar styles for consistent display
export const getPharmacistAvatarProps = (
  pharmacist: PharmacistProfile,
  size: "sm" | "md" | "lg" = "md",
) => {
  const sizeClasses = {
    sm: "w-6 h-6 text-xs",
    md: "w-8 h-8 text-sm",
    lg: "w-12 h-12 text-base",
  };

  const baseClasses = `${sizeClasses[size]} rounded-full flex items-center justify-center border-2 border-gray-200 dark:border-gray-600`;

  if (pharmacist.avatar) {
    return {
      type: "image" as const,
      src: pharmacist.avatar,
      alt: pharmacist.name,
      className: `${baseClasses} object-cover`,
    };
  }

  return {
    type: "initials" as const,
    initials: pharmacist.initials,
    className: `${baseClasses} bg-blue-500 text-white font-medium`,
  };
};

// Helper function to get just pharmacist names for components that only need names
export const getPharmacistNames = (
  pharmacistProfiles: PharmacistProfile[],
): string[] => {
  return pharmacistProfiles.map((profile) => profile.name);
};

// Helper function to get room display data for UI
export const getRoomDisplayData = (room: RoomProfile) => {
  return {
    id: room.id,
    name: room.name,
    hasAvatar: !!room.avatar,
    avatar: room.avatar,
    initials: room.initials,
    type: room.type,
    services: room.services,
  };
};

// Helper function to get room avatar props for consistent display
export const getRoomAvatarProps = (
  room: RoomProfile,
  size: "sm" | "md" | "lg" = "md",
) => {
  const sizeClasses = {
    sm: "w-6 h-6 text-xs",
    md: "w-8 h-8 text-sm",
    lg: "w-12 h-12 text-base",
  };

  const baseClasses = `${sizeClasses[size]} rounded-full flex items-center justify-center border-2 border-gray-200 dark:border-gray-600`;

  if (room.avatar) {
    return {
      type: "image" as const,
      src: room.avatar,
      alt: room.name,
      className: `${baseClasses} object-cover`,
    };
  }

  return {
    type: "initials" as const,
    initials: room.initials,
    className: `${baseClasses} bg-green-500 text-white font-medium`,
  };
};

// Helper function to get just room names for components that only need names
export const getRoomNames = (roomProfiles: RoomProfile[]): string[] => {
  return roomProfiles.map((profile) => profile.name);
};

// Extract pharmacists with complete profile information
const extractPharmacistsFromResources = (
  resources: APIResource[],
): PharmacistProfile[] => {
  return resources
    .filter((resource) => resource.resourceType === 1)
    .map((resource) => {
      const profile: PharmacistProfile = {
        id: resource.id,
        name: resource.name,
        initials: generateInitials(resource.name),
        // Avatar can be added here when available from API
        // For now, we'll leave it undefined to use initials
        avatar: undefined,
        // Specialty can be derived from services if needed
        specialty:
          resource.services !== null
            ? resource.services.length > 0
              ? "General Pharmacist"
              : "Pharmacist"
            : "Pharmacist",
        role: resource.role?.roleName,
      };

      return profile;
    });
};

// Extract rooms with complete profile information
const extractRoomsFromResources = (resources: APIResource[]): RoomProfile[] => {
  return resources
    .filter((resource) => resource.resourceType === 2)
    .map((resource) => {
      const profile: RoomProfile = {
        id: resource.id,
        name: resource.name,
        initials: generateInitials(resource.name),
        // Avatar can be added here when available from API
        avatar: undefined,
        type: "Consultation Room",
        services: resource.services.map((s) => s.serviceName),
      };

      return profile;
    });
};

const extractServiceTypesFromServices = (services: APIService[]): string[] => {
  return services.map((service) => service.serviceName);
};

interface ServiceTypeInfo {
  _id: string;
  name: string;
  label: string;
  color: string;
  serviceType: number;
  serviceColor: string;
  serviceCharges: number;
  serviceDuration: number;
  isDefault: boolean;
  companyID: string | null;
  serviceDescription: string;
  notificationTemplates: any[];
  serviceCode: number;
  isOnlineBooking: boolean;
  availability:
    | {
        dayOfWeek: number;
        slots: { startTime: string; endTime: string }[];
      }[]
    | null;
  isRoomRequired: boolean;
}

const extractServiceTypesInfo = (services: APIService[]): ServiceTypeInfo[] => {
  return services.map((service) => ({
    _id: service._id,
    name: service.serviceName,
    label: service.serviceName,
    color: hexToTailwindColor(service.serviceColor),
    serviceType: service.serviceType,
    serviceColor: service.serviceColor,
    serviceCharges: service.serviceCharges,
    serviceDuration: service.serviceDuration,
    isDefault: service.isDefault,
    companyID: service.companyID,
    serviceDescription: service.serviceDescription,
    notificationTemplates: service.notificationTemplates,
    serviceCode: service.serviceCode,
    isOnlineBooking: service.isOnlineBooking,
    availability: service.availability,
    isRoomRequired: service.isRoomRequired,
  }));
};

const mapCalendarAppointmentServices = (services: any[] | any = []) => {
  const serviceList = Array.isArray(services)
    ? services
    : Array.isArray(services?.response)
    ? services.response
    : [];

  return serviceList.map((service: any) => ({
    _id: service?._id,
    isActive: service?.isActive,
    serviceName: service?.serviceName,
    serviceType: service?.serviceType,
    serviceDuration: service?.serviceDuration,
    isRoomRequired: service?.isRoomRequired,
    serviceUnavailableOnDay: service?.serviceUnavailableOnDay,
    serviceStartDate: service?.serviceStartDate,
    serviceEndDate: service?.serviceEndDate,
  }));
};

// Utility functions (keeping existing ones)
export const getBookingsForDate = (
  bookings: Booking[],
  date: string,
): Booking[] => {
  return bookings.filter((booking) => booking.date === date);
};

export const getBookingsForTimeSlot = (
  bookings: Booking[],
  date: string,
  hour: number,
): Booking[] => {
  return bookings.filter((booking) => {
    if (booking.date !== date) return false;
    if (!booking.time) return false;
    const [hh, mm] = booking.time.split(":");
    const startHour = parseInt(hh, 10);
    const startMin = parseInt(mm || "0", 10);
    const durationMin =
      typeof booking.duration === "number"
        ? booking.duration
        : parseInt(String(booking.duration || 0), 10) || 0;
    const startTotal = startHour * 60 + startMin;
    const endTotal = startTotal + durationMin;
    const slotStart = hour * 60;
    const slotEnd = (hour + 1) * 60;
    // Show booking if it overlaps this hour slot at all
    return startTotal < slotEnd && endTotal > slotStart;
  });
};

export const formatDate = (
  year: number,
  month: number,
  day: number,
): string => {
  return `${year}-${String(month + 1).padStart(2, "0")}-${String(day).padStart(
    2,
    "0",
  )}`;
};

export const formatDateFromDate = (date: Date): string => {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0",
  )}-${String(date.getDate()).padStart(2, "0")}`;
};

export interface BlockOutMultiDayInfo {
  isMultiDay: boolean;
  startDate: string;
  endDate: string;
  durationHours: number;
}

export const detectBlockOutMultiDayInfo = (
  blockOut: any,
): BlockOutMultiDayInfo => {
  if (!blockOut) {
    return { isMultiDay: false, startDate: "", endDate: "", durationHours: 0 };
  }

  let sDate = blockOut.startDate || blockOut.date || blockOut.StartDate || "";
  let eDate = blockOut.endDate || blockOut.date || blockOut.EndDate || sDate;

  if (typeof sDate === "string" && sDate.includes("T")) {
    sDate = sDate.split("T")[0];
  }
  if (typeof eDate === "string" && eDate.includes("T")) {
    eDate = eDate.split("T")[0];
  }

  let sTime = blockOut.startTime || "00:00";
  let eTime = blockOut.endTime || "23:59";

  if (
    blockOut.StartDate &&
    typeof blockOut.StartDate === "string" &&
    blockOut.StartDate.includes("T")
  ) {
    const parts = blockOut.StartDate.split("T")[1]?.substring(0, 5);
    if (parts) sTime = parts;
  }
  if (
    blockOut.EndDate &&
    typeof blockOut.EndDate === "string" &&
    blockOut.EndDate.includes("T")
  ) {
    const parts = blockOut.EndDate.split("T")[1]?.substring(0, 5);
    if (parts) eTime = parts;
  }

  let durationHours = 0;
  try {
    if (sDate && eDate) {
      const startDateTime = new Date(
        `${sDate}T${sTime.length === 5 ? sTime : "00:00"}`,
      );
      const endDateTime = new Date(
        `${eDate}T${eTime.length === 5 ? eTime : "23:59"}`,
      );
      const diffMs = endDateTime.getTime() - startDateTime.getTime();
      if (!isNaN(diffMs) && diffMs > 0) {
        durationHours = diffMs / (1000 * 60 * 60);
      }
    }
  } catch {
    durationHours = 0;
  }

  const isMultiDay = sDate !== eDate || durationHours >= 24;

  return {
    isMultiDay,
    startDate: sDate,
    endDate: eDate || sDate,
    durationHours,
  };
};

// Block-out utility functions
export const getBlockOutsForDate = (
  blockOuts: BlockOut[],
  date: string,
): BlockOut[] => {
  return (blockOuts || []).filter((blockOut) => {
    const sDate = blockOut.startDate || blockOut.date || "";
    const eDate = blockOut.endDate || blockOut.startDate || blockOut.date || "";
    if (!sDate) return false;
    return date >= sDate && date <= eDate;
  });
};

export const getBlockOutsForTimeSlot = (
  blockOuts: BlockOut[],
  date: string,
  hour: number,
): BlockOut[] => {
  return (blockOuts || []).filter((blockOut) => {
    let sDate = blockOut.startDate || blockOut.date || "";
    let eDate = blockOut.endDate || blockOut.startDate || blockOut.date || "";
    if (typeof sDate === "string" && sDate.includes("T"))
      sDate = sDate.split("T")[0];
    if (typeof eDate === "string" && eDate.includes("T"))
      eDate = eDate.split("T")[0];

    if (!sDate) return false;
    if (date < sDate || date > eDate) return false;

    // Check if it's an all-day blockout: render on the first slot of the day
    if (
      (blockOut as any).isAllDay ||
      (!blockOut.startTime && !blockOut.endTime) ||
      (blockOut.startTime === "00:00" && blockOut.endTime === "23:59")
    ) {
      return hour === 8 || hour === 0;
    }

    const startHour = parseInt(
      (blockOut.startTime || "00:00").split(":")[0],
      10,
    );

    if (date === sDate) {
      if (startHour < 8) {
        return hour === 8 || hour === 0;
      }
      return hour === startHour;
    } else {
      return hour === 8 || hour === 0;
    }
  });
};

// Pre-computed time slots to avoid recreation in UI
export const TIME_SLOTS = Array.from({ length: 25 }, (_, i) => i); // 0 → 24

type ModalState =
  | { isOpen: false; mode: null; booking?: Booking; initialDate?: string }
  | { isOpen: true; mode: "create"; booking?: undefined; initialDate?: string }
  | { isOpen: true; mode: "edit"; booking: Booking; initialDate?: undefined };

export interface UseScheduleDataReturn {
  // theme
  isDarkMode: boolean;
  isEventsLoading: boolean;
  isEventCalendarLoading: boolean;
  isScheduleEventsByPharmaciesLoading: boolean;
  isPatientDetailsLoading: boolean;

  // core state
  currentDate: Date;
  view: "month" | "week" | "day";
  calendarSelectedDate: Date;
  modalState: ModalState;

  // data
  pharmacists: PharmacistProfile[];
  pharmacistNames: string[];
  // Pharmacists fetched by selected service (Booking modal)
  servicePharmacists: PharmacistProfile[];
  // Rooms derived from resources (all rooms)
  rooms: RoomProfile[];
  roomNames: string[];
  pharmacyRooms: any[];
  // Rooms filtered by selected service (Booking modal)
  serviceRooms: { id: string; name: string }[];
  // Duration options derived from selected service (Booking modal)
  serviceDurations: { value: string; label: string }[];
  serviceTypes: string[];
  serviceTypesInfo: ServiceTypeInfo[];
  blockOutTypes: typeof blockOutTypes;
  serviceColors: ReturnType<typeof getServiceColors>;
  serviceColorsFromData: ReturnType<typeof getServiceColorsFromData>;
  timeSlots: number[];
  dayNames: string[];
  currentPharmacyId?: string;
  companyId?: string;
  appointmentRooms: string[];
  isAppointmentRoomsLoading: boolean;
  currentUser?: any;

  // Availability from active pharmacist and priority availability lookups
  availableDates: string[]; // yyyy-MM-dd
  // Date and slot count of the last get-pharmacy-available-slots result.
  pharmacyAvailableSlotsDate: string;
  pharmacyAvailableSlotsCount: number;
  isPharmacistBookedAtSlot: (
    date: string,
    time: string,
    duration: number,
    pharmacist: { id?: string; name?: string },
  ) => boolean;
  // Slot the current get-active-pharmacists flags (isAlreadyBooked etc.) were computed for.
  activePharmacistsRequest: {
    serviceId: string;
    date: string;
    duration: number;
    startTime: string;
  } | null;
  getAvailableTimesForDate: (date: string) => string[]; // HH:mm
  getAggregatedTimesForDate: (date: string, intervalMin: number) => string[];
  // General availability window (e.g. 09:00-17:00) a service is bookable
  // within on a given date, used to bound "ad-hoc" manually-typed times.
  getServiceAvailabilityWindowForDate: (
    date: string,
    serviceId: string,
    pharmacistId?: string,
  ) => { startTime: string; endTime: string } | null;
  // Raw per-service weekly availability slots for a given date/pharmacist,
  // used to split bookable times into "in hours" vs "ad-hoc" groups. Null
  // means the pharmacist's hours aren't known yet (fail open); an empty
  // array means they're known and are genuinely not working that day.
  getServicePharmacistSlotsForDate: (
    date: string,
    serviceId: string,
    pharmacistId?: string,
    serviceName?: string,
  ) => { startTime: string; endTime: string }[] | null;
  // Same idea, but for rooms that support the service (room-availability
  // analogue of getServicePharmacistSlotsForDate).
  getServiceRoomSlotsForDate: (
    date: string,
    serviceId: string,
  ) => { startTime: string; endTime: string }[] | null;
  // Discrete HH:mm slots from the pharmacist's userWeekAvailability, stepped
  // by service duration - source of truth for toggle OFF / ON comparison.
  getPharmacistWeekAvailabilitySlots: (
    date: string,
    pharmacistId: string | undefined,
    durationMinutes: number,
  ) => string[] | null;

  // filters
  selectedPharmacists: string[];
  selectedServiceTypes: string[];
  selectedPharmacies: string[];
  selectedRooms: string[];
  selectedBlockOutTypes: string[];
  myAppointments: any[];
  defaultPharmacyServices: any[];
  bookingModalServices: any[];
  pharmacies: any[];

  // filtered accessors
  getDaysInMonth: (date: Date) => (number | null)[];
  getWeekDays: (date: Date) => Date[];
  getFilteredBookingsForDate: (date: string) => Booking[];
  getFilteredBookingsForTimeSlot: (date: string, hour: number) => Booking[];
  getFilteredBlockOutsForDate: (date: string) => BlockOut[];
  getFilteredBlockOutsForTimeSlot: (date: string, hour: number) => BlockOut[];

  // utils
  formatDate: typeof formatDate;
  formatDateFromDate: typeof formatDateFromDate;
  getViewTitle: () => string;

  // actions (navigation / calendar)
  navigate: (dir: "prev" | "next") => void;
  onCalendarSelect: (date: Date | undefined) => void;
  handleViewDay: (dateString: string) => void;

  // actions (filters)
  handleServiceTypeChange: (serviceType: string, checked: boolean) => void;
  handlePharmacistChange: (pharmacist: string, checked: boolean) => void;
  handlePharmacyChange: (pharmacyId: string, checked: boolean) => void;
  handleSelectAllServices: (checked: boolean) => void;
  handleSelectAllPharmacies: (checked: boolean) => void;
  handleSelectAllPharmacists: (checked: boolean) => void;
  handleRoomChange: (room: string, checked: boolean) => void;
  handleSelectAllRooms: (checked: boolean) => void;
  handleBlockOutTypeChange: (type: string, checked: boolean) => void;
  handleSelectAllBlockOutTypes: (checked: boolean) => void;
  handleStartConsultation: (b: any) => void;
  handleGetAppointmentRooms: (b: any) => Promise<any>;

  // actions (bookings + block outs)
  onCreateBooking: (bookingData: any) => void;
  onCreateBookingForDate: (dateString: string) => void;
  onShowEditBooking: (bookingId: string, booking: Booking) => void;
  onEditBooking: (bookingId: string, bookingData: any) => void;
  onDeleteBooking: (bookingId: string) => void;

  onCreateBlockOut: (blockOutData: any) => void;
  onEditBlockOut: (
    blockOutId: string,
    blockOutData: any,
    otherPharmacyId?: string,
  ) => void;
  onDeleteBlockOut: (blockOutId: string, otherPharmacyId?: string) => void;

  // modal wiring
  openNewAppointment: () => void;
  closeModal: () => void;
  validatePharmacySlots: (data: any) => ValidationResult;
  validateBookingConflicts: (
    data: any,
    excludeBookingId?: string,
  ) => ValidationResult;
  validateBlockOutConflicts: (
    data: any,
    excludeBlockOutId?: string,
  ) => ValidationResult;
  onSaveFromModal: (data: any) => void;
  setView: (v: "month" | "week" | "day") => void;

  // service selection side-effect
  onServiceTypeSelected: (data: any) => Promise<any>;
  resetServiceUsersFetchGuard: () => void;
  onPharmacistSelected: (
    serviceId: string,
    pharmacistResourceId: string,
    overridePharmacyId?: string,
    loadLegacyAvailability?: boolean,
  ) => Promise<void>;
  onAnyPharmacistSelected: (
    serviceId: string,
    overridePharmacyId?: string,
  ) => Promise<void>;

  // conflict warning UI state
  conflictWarning: string | null;
  clearConflictWarning: () => void;

  selectedPatientConsultation: any;
  showMyAppointmentsOnly: boolean;
  setShowMyAppointmentsOnly: React.Dispatch<React.SetStateAction<boolean>>;
}

export function useProvideScheduleData(): UseScheduleDataReturn {
  const {
    appState,
    scheduleEventState,
    pharmacyServiceState,
    patientState,
  } = useTitanApp();
  const routerNavigate = useNavigate();
  const location = useLocation();
  const { darkMode, currentPharmacyId, companyId, features, pharmacies } =
    appState || {};
  const { ifPharmacyDashboardEnabled, ifScheduleTabEnabled, ifNewCalendar } =
    features || {};
  const {
    scheduleEvents = [],
    resources: rawResources = [],
    pharmacistResources = [],
    isEventsLoading,
    isEventCalendarLoading,
    userAvailibility,
    bookingSlotsMode,
    myAppointments,
    scheduleEventsBySelectedPharmacies,
    isScheduleEventsByPharmaciesLoading = false,
  } = scheduleEventState || {};

  // The Calendar ("schedule-new") route never fetches into `resources` - it fetches
  // pharmacists/rooms into `pharmacistResources` instead (see useTitanApp.jsx's
  // appDataHandler). Fall back to that so shared logic here (mergedBookings,
  // validateBlockOutConflicts, etc.) still has resource data when used from that tab.
  const resources =
    rawResources.length > 0 ? rawResources : pharmacistResources;

  const {
    consultationData,
    preConsultData,
    isPatientDetailsLoading,
    consultationId,
    selectedPatientConsultation,
  } = patientState || {};
  // Build availability map from API response
  const availabilityMap = useMemo(() => {
    const map: Record<string, string[]> = {};
    try {
      const arr = Array.isArray(userAvailibility) ? userAvailibility : [];
      arr.forEach((entry: any) => {
        const freeSlots = (entry && entry.freeSlots) || {};
        Object.keys(freeSlots || {}).forEach((dayKey) => {
          const slots = Array.isArray(freeSlots[dayKey])
            ? freeSlots[dayKey]
            : [];
          slots.forEach((s: any) => {
            if (!s?.date || !s?.start) return;
            const d = new Date(String(s.date));
            if (isNaN(d.getTime())) return;
            const y = d.getUTCFullYear();
            const m = String(d.getUTCMonth() + 1).padStart(2, "0");
            const day = String(d.getUTCDate()).padStart(2, "0");
            const key = `${y}-${m}-${day}`;
            const time = String(s.start).slice(0, 5);
            if (!map[key]) map[key] = [];
            if (!map[key].includes(time)) map[key].push(time);
          });
        });
      });
      Object.keys(map).forEach((k) => map[k].sort());
    } catch {}

    return map;
  }, [userAvailibility]);
  const {
    serviceUsersByCompany = [],
    // Rich per-service user list (with per-service weekly availability),
    // untouched by getActivePharmacistsData which overwrites
    // serviceUsersByCompany with a leaner isAlreadyBooked/isOutsideWorkingHours
    // list only. Use this for anything reading per-service availability.
    serviceUsersDetailsByCompany = [],
    serviceRoomsByCompany = [],
    defaultPharmacyServices = [],
    defaultCalenderAppointmentPharmacyServices = [],
    pharmacyOpeningHours = [],
    pharmacyAvailableSlots = [],
    pharmacyAvailableSlotsDate = "",
    appointmentRooms,
    isAppointmentRoomsLoading,
  } = pharmacyServiceState || {};
  const { currentPharmacy } = appState || {};

  const endpointAvailableTimes = useMemo(
    () =>
      Array.isArray(pharmacyAvailableSlots)
        ? pharmacyAvailableSlots
            .map((slot: any) => String(slot || "").slice(0, 5))
            .filter(Boolean)
            .sort()
        : [],
    [pharmacyAvailableSlots],
  );

  const calendarAppointmentServices = useMemo(
    () =>
      mapCalendarAppointmentServices(
        defaultCalenderAppointmentPharmacyServices,
      ),
    [defaultCalenderAppointmentPharmacyServices],
  );

  const schedulerAvailableDates = useMemo(() => {
    const dates = new Set(Object.keys(availabilityMap));
    if (endpointAvailableTimes.length && pharmacyAvailableSlotsDate) {
      dates.add(pharmacyAvailableSlotsDate);
    }
    return Array.from(dates).sort();
  }, [availabilityMap, endpointAvailableTimes, pharmacyAvailableSlotsDate]);

  const getSchedulerAvailableTimesForDate = useCallback(
    (date: string) => {
      if (
        endpointAvailableTimes.length &&
        (!pharmacyAvailableSlotsDate || date === pharmacyAvailableSlotsDate)
      ) {
        return [...endpointAvailableTimes];
      }

      return availabilityMap[date] ? [...availabilityMap[date]] : [];
    },
    [availabilityMap, endpointAvailableTimes, pharmacyAvailableSlotsDate],
  );

  // Aggregated times across all service users' weekly availability for a given date
  const getAggregatedTimesForDate = useCallback(
    (date: string, intervalMin: number) => {
      try {
        if (
          !Array.isArray(serviceUsersDetailsByCompany) ||
          !serviceUsersDetailsByCompany.length
        )
          return [] as string[];
        const d = new Date(String(date));
        if (isNaN(d.getTime())) return [] as string[];
        const dayOfWeek = d.getDay(); // 0-6
        const pad = (n: number) => String(n).padStart(2, "0");
        const toTime = (mins: number) =>
          `${pad(Math.floor(mins / 60))}:${pad(mins % 60)}`;

        let minStart: number | null = null;
        let maxEnd: number | null = null;
        for (const u of serviceUsersDetailsByCompany as any[]) {
          // Weekly availability doesn't apply outside the user's access dates.
          if (!hasAccessOn(u?.startDate, u?.endDate, date)) continue;
          const week = Array.isArray(u?.userWeekAvailability)
            ? u.userWeekAvailability
            : [];
          const day = week.find(
            (w: any) => Number(w?.dayOfWeek) === Number(dayOfWeek),
          );
          const slots = Array.isArray(day?.slots) ? day.slots : [];
          for (const s of slots) {
            const [sh, sm] = String(s?.startTime || "00:00").split(":");
            const [eh, em] = String(s?.endTime || "00:00").split(":");
            const st = parseInt(sh || "0", 10) * 60 + parseInt(sm || "0", 10);
            const et = parseInt(eh || "0", 10) * 60 + parseInt(em || "0", 10);
            if (et > st) {
              if (minStart === null || st < minStart) minStart = st;
              if (maxEnd === null || et > maxEnd) maxEnd = et;
            }
          }
        }
        if (minStart === null || maxEnd === null) return [] as string[];
        const out: string[] = [];
        for (let m = minStart; m + intervalMin <= maxEnd; m += intervalMin) {
          out.push(toTime(m));
        }
        return out;
      } catch {
        return [] as string[];
      }
    },
    [serviceUsersDetailsByCompany],
  );

  // Raw per-service weekly availability slots (e.g. [{startTime:"09:00",
  // endTime:"13:00"}]) for a given date, derived from
  // get-users-by-serviceID-companyID-pharmacyID. Used to tell whether a given
  // bookable time is within the selected pharmacist's own hours for the
  // service ("bookable") or merely within the pharmacy/service's general
  // hours ("ad-hoc"). When pharmacistId is omitted or "any", slots are
  // unioned across every pharmacist offering the service.
  //
  // Returns null when the service's user list hasn't loaded yet, or the
  // requested pharmacist genuinely isn't in it at all (fail open while
  // unknown, rather than guessing). When the pharmacist IS found but has no
  // day entry under this exact service (sparse per-service data), falls back
  // to their general userWeekAvailability for that day instead of treating
  // it as zero slots.
  const getServicePharmacistSlotsForDate = useCallback(
    (
      date: string,
      serviceId: string,
      pharmacistId?: string,
      serviceName?: string,
    ) => {
      try {
        if (
          !date ||
          !serviceId ||
          !Array.isArray(serviceUsersDetailsByCompany) ||
          !serviceUsersDetailsByCompany.length
        )
          return null;
        const d = new Date(String(date));
        if (isNaN(d.getTime())) return null;
        const dayOfWeek = d.getDay(); // 0-6

        const normalizeEmail = (v: any) =>
          String(v || "")
            .trim()
            .toLowerCase();
        const normalizedServiceName = String(serviceName || "")
          .trim()
          .toLowerCase();

        const allUsers = serviceUsersDetailsByCompany as any[];
        const relevantUsers =
          pharmacistId && pharmacistId !== "any"
            ? allUsers.filter(
                (u: any) =>
                  normalizeEmail(u?.emailAddress) ===
                  normalizeEmail(pharmacistId),
              )
            : allUsers;

        // A specific pharmacist was requested but genuinely isn't in the
        // loaded list - we have no data for them, don't guess.
        if (pharmacistId && pharmacistId !== "any" && !relevantUsers.length)
          return null;

        const slotsForUser = (u: any) => {
          const services = Array.isArray(u?.services) ? u.services : [];
          // Match by id first, falling back to name in case the service
          // dropdown's catalog and this endpoint's service ids diverge.
          const svc =
            services.find((s: any) => String(s?._id) === String(serviceId)) ||
            (normalizedServiceName
              ? services.find(
                  (s: any) =>
                    String(s?.serviceName || "")
                      .trim()
                      .toLowerCase() === normalizedServiceName,
                )
              : undefined);
          const svcDay = Array.isArray(svc?.availability)
            ? svc.availability.find(
                (a: any) => Number(a?.dayOfWeek) === Number(dayOfWeek),
              )
            : null;
          const svcSlots = Array.isArray(svcDay?.slots) ? svcDay.slots : [];
          if (svcSlots.length) return svcSlots;

          // This service has no (or an empty) day entry for this pharmacist -
          // fall back to their general weekly working hours for the day.
          const weekDay = Array.isArray(u?.userWeekAvailability)
            ? u.userWeekAvailability.find(
                (w: any) => Number(w?.dayOfWeek) === Number(dayOfWeek),
              )
            : null;
          return Array.isArray(weekDay?.slots) ? weekDay.slots : [];
        };

        const windows: { startTime: string; endTime: string }[] = [];
        for (const u of relevantUsers) {
          // Weekly availability doesn't apply outside the user's access dates.
          if (!hasAccessOn(u?.startDate, u?.endDate, date)) continue;
          for (const s of slotsForUser(u)) {
            if (s?.startTime && s?.endTime) {
              windows.push({ startTime: s.startTime, endTime: s.endTime });
            }
          }
        }
        return windows;
      } catch {
        return null;
      }
    },
    [serviceUsersDetailsByCompany],
  );

  // Discrete HH:mm slots generated from the selected pharmacist's OWN
  // `userWeekAvailability` (general weekly working hours, NOT per-service
  // availability), stepped in the given service's duration increments. This
  // is the source of truth for the "toggle OFF" bookable list and for the
  // toggle-ON normal-vs-ad-hoc comparison against the pharmacy's slots. When
  // pharmacistId is omitted or "any", unions across every loaded user. null
  // = not known yet (list not loaded, or a specific pharmacist requested
  // but not found at all); [] = known and genuinely no availability that day.
  const getPharmacistWeekAvailabilitySlots = useCallback(
    (
      date: string,
      pharmacistId: string | undefined,
      durationMinutes: number,
    ) => {
      try {
        if (
          !date ||
          !durationMinutes ||
          !Array.isArray(serviceUsersDetailsByCompany) ||
          !serviceUsersDetailsByCompany.length
        )
          return null;
        const d = new Date(String(date));
        if (isNaN(d.getTime())) return null;
        const dayOfWeek = d.getDay(); // 0=Sun..6=Sat, matches API's dayOfWeek

        const normalizeEmail = (v: any) =>
          String(v || "")
            .trim()
            .toLowerCase();

        const allUsers = serviceUsersDetailsByCompany as any[];
        const relevantUsers =
          pharmacistId && pharmacistId !== "any"
            ? allUsers.filter(
                (u: any) =>
                  normalizeEmail(u?.emailAddress) ===
                  normalizeEmail(pharmacistId),
              )
            : allUsers;

        if (pharmacistId && pharmacistId !== "any" && !relevantUsers.length)
          return null;

        const toMinutes = (t: string) => {
          const [h, m] = String(t || "00:00").split(":");
          return parseInt(h || "0", 10) * 60 + parseInt(m || "0", 10);
        };
        const toTime = (mins: number) => {
          const h = Math.floor(mins / 60)
            .toString()
            .padStart(2, "0");
          const m = (mins % 60).toString().padStart(2, "0");
          return `${h}:${m}`;
        };

        const slotSet = new Set<string>();
        for (const u of relevantUsers) {
          // Weekly availability doesn't apply outside the user's access dates.
          if (!hasAccessOn(u?.startDate, u?.endDate, date)) continue;
          const weekDay = Array.isArray(u?.userWeekAvailability)
            ? u.userWeekAvailability.find(
                (w: any) => Number(w?.dayOfWeek) === Number(dayOfWeek),
              )
            : null;
          const slots = Array.isArray(weekDay?.slots) ? weekDay.slots : [];
          for (const s of slots) {
            if (!s?.startTime || !s?.endTime) continue;
            const start = toMinutes(s.startTime);
            const end = toMinutes(s.endTime);
            // Dedupes duplicate/overlapping availability entries naturally.
            for (
              let t = start;
              t + durationMinutes <= end;
              t += durationMinutes
            ) {
              slotSet.add(toTime(t));
            }
          }
        }
        return Array.from(slotSet).sort();
      } catch {
        return null;
      }
    },
    [serviceUsersDetailsByCompany],
  );

  // General availability window (start/end) for a given service on a given
  // date - the min/max bound across getServicePharmacistSlotsForDate's slots.
  const getServiceAvailabilityWindowForDate = useCallback(
    (date: string, serviceId: string, pharmacistId?: string) => {
      const windows = getServicePharmacistSlotsForDate(
        date,
        serviceId,
        pharmacistId,
      );
      if (!windows || !windows.length) return null;
      const parseMins = (t: string) => {
        const [h, m] = String(t || "00:00").split(":");
        return parseInt(h || "0", 10) * 60 + parseInt(m || "0", 10);
      };
      const pad = (n: number) => String(n).padStart(2, "0");
      const toTime = (mins: number) =>
        `${pad(Math.floor(mins / 60))}:${pad(mins % 60)}`;
      let minStart: number | null = null;
      let maxEnd: number | null = null;
      for (const w of windows) {
        const st = parseMins(w.startTime);
        const et = parseMins(w.endTime);
        if (et > st) {
          if (minStart === null || st < minStart) minStart = st;
          if (maxEnd === null || et > maxEnd) maxEnd = et;
        }
      }
      if (minStart === null || maxEnd === null) return null;
      return { startTime: toTime(minStart), endTime: toTime(maxEnd) };
    },
    [getServicePharmacistSlotsForDate],
  );

  // Raw weekly availability slots for rooms that support the given service,
  // for the given date's day-of-week - the room-availability analogue of
  // getServicePharmacistSlotsForDate. Only active rooms whose `services`
  // list includes the serviceId are considered; their windows are unioned
  // (any one of them being free is enough for the slot to be "bookable").
  // Same null ("not loaded yet", fail open) vs [] ("loaded, no suitable room
  // available that day") semantics.
  const getServiceRoomSlotsForDate = useCallback(
    (date: string, serviceId: string) => {
      try {
        if (
          !date ||
          !serviceId ||
          !Array.isArray(serviceRoomsByCompany) ||
          !serviceRoomsByCompany.length
        )
          return null;
        const d = new Date(String(date));
        if (isNaN(d.getTime())) return null;
        const dayOfWeek = d.getDay(); // 0-6

        const relevantRooms = (serviceRoomsByCompany as any[]).filter(
          (room: any) => {
            if (room?.active === false) return false;
            const services = Array.isArray(room?.services) ? room.services : [];
            return services.some(
              (s: any) => String(s?._id) === String(serviceId),
            );
          },
        );

        if (!relevantRooms.length) return null;

        const windows: { startTime: string; endTime: string }[] = [];
        for (const room of relevantRooms) {
          const dayAvailability = Array.isArray(room?.availability)
            ? room.availability.find(
                (a: any) => Number(a?.dayOfWeek) === Number(dayOfWeek),
              )
            : null;
          const slots = Array.isArray(dayAvailability?.slots)
            ? dayAvailability.slots
            : [];
          for (const s of slots) {
            if (s?.startTime && s?.endTime) {
              windows.push({ startTime: s.startTime, endTime: s.endTime });
            }
          }
        }
        return windows;
      } catch {
        return null;
      }
    },
    [serviceRoomsByCompany],
  );
  const isDarkMode = darkMode;
  const [currentDate, setCurrentDate] = useState(new Date());
  const [view, setView] = useState<"month" | "week" | "day">("month");
  const [calendarSelectedDate, setCalendarSelectedDate] = useState(new Date());
  const [selectedPharmacists, setSelectedPharmacists] = useState<string[]>([]);
  const [selectedServiceTypes, setSelectedServiceTypes] = useState<string[]>(
    [],
  );
  const [selectedRooms, setSelectedRooms] = useState<string[]>([]);
  const [selectedBlockOutTypes, setSelectedBlockOutTypes] = useState<string[]>(
    [],
  );
  const [modalState, setModalState] = useState<ModalState>({
    isOpen: false,
    mode: null,
  });
  const [otherPharmacyIdForBooking, setOtherPharmacyIdForBooking] = useState<
    string | null
  >(null);
  const [activePharmacistsRequest, setActivePharmacistsRequest] = useState<{
    serviceId: string;
    date: string;
    duration: number;
    startTime: string;
  } | null>(null);

  const [showMyAppointmentsOnly, setShowMyAppointmentsOnly] = useState(false);
  const [selectedPharmacies, setSelectedPharmacies] = useState<string[]>([]);

  useEffect(() => {
    const isScheduleRoute = location.pathname.includes("/pharmacy/schedule/");
    if (isScheduleRoute) {
      setSelectedPharmacies([]);
    }
  }, [location.pathname, companyId, currentPharmacyId, pharmacies?.length]);

  const effectiveScheduleEvents = useMemo(() => {
    if (Array.isArray(selectedPharmacies) && selectedPharmacies.length > 0) {
      // Pharmacies are actively selected — use their results only (even if empty)
      return Array.isArray(scheduleEventsBySelectedPharmacies)
        ? scheduleEventsBySelectedPharmacies
        : [];
    }
    return scheduleEvents;
  }, [selectedPharmacies, scheduleEventsBySelectedPharmacies, scheduleEvents]);

  // Transform API data to match existing interfaces
  const bookings = useMemo(() => {
    return transformAPIEventsToBookings(
      effectiveScheduleEvents,
      resources,
      defaultPharmacyServices,
      pharmacies,
      currentPharmacyId,
    );
  }, [effectiveScheduleEvents, resources, defaultPharmacyServices, pharmacies]);

  // Local optimistic state for bookings (create/update/delete) to avoid refetching
  const [localAdds, setLocalAdds] = useState<Booking[]>([]);
  const [localUpdates, setLocalUpdates] = useState<Record<string, Booking>>({});
  const [localDeletes, setLocalDeletes] = useState<Set<string>>(new Set());

  const mergedBookings = useMemo(() => {
    const byId = new Map<string, Booking>();
    // start with remote bookings
    bookings.forEach((b) => {
      if (!localDeletes.has(b.id)) {
        byId.set(b.id, b);
      }
    });
    // apply updates
    Object.keys(localUpdates).forEach((id) => {
      const upd = localUpdates[id];
      if (!localDeletes.has(id)) byId.set(id, upd);
    });
    // add local additions — only include if they match selected pharmacy filter
    localAdds.forEach((b) => {
      if (localDeletes.has(b.id)) return;
      // If there are selected pharmacies, only include local add if its pharmacy matches
      if (
        Array.isArray(selectedPharmacies) &&
        selectedPharmacies.length > 0 &&
        String(b.otherPharmacyId || "").trim() !== "" &&
        !selectedPharmacies.includes(String(b.otherPharmacyId))
      ) {
        return;
      }
      byId.set(b.id, b);
    });

    const list = Array.from(byId.values());
    // keep ordering consistent (date then time)
    list.sort((a, b) => {
      const dateCompare = a.date.localeCompare(b.date);
      if (dateCompare !== 0) return dateCompare;
      return a.time.localeCompare(b.time);
    });
    return list;
  }, [bookings, localAdds, localUpdates, localDeletes]);

  const pharmacists = useMemo(() => {
    return extractPharmacistsFromResources(resources);
  }, [resources]);

  const pharmacistNames = useMemo(() => {
    return getPharmacistNames(pharmacists);
  }, [pharmacists]);
  const pharmacistNameToId = useMemo(
    () =>
      new Map(
        pharmacists.map((p) => [
          String(p.name)
            .trim()
            .toLowerCase(),
          String(p.id),
        ]),
      ),
    [pharmacists],
  );
  const pharmacistIdToName = useMemo(
    () => new Map(pharmacists.map((p) => [String(p.id), p.name])),
    [pharmacists],
  );
  // Pharmacists returned by getUsersByServiceID API
  const servicePharmacists: PharmacistProfile[] = useMemo(() => {
    if (!Array.isArray(serviceUsersByCompany)) return [] as any;
    const mapped = serviceUsersByCompany
      .map((u: any) => {
        const id = u?.emailAddress || "";
        const name =
          u?.name ||
          [u?.firstName, u?.lastName].filter(Boolean).join(" ") ||
          u?.fullName ||
          "";
        if (!id || !name) return null;
        return {
          id: String(id),
          name: String(name),
          isAlreadyBooked: Boolean(u?.isAlreadyBooked),
          isOutsideWorkingHours: Boolean(u?.isOutsideWorkingHours),
        } as PharmacistProfile;
      })
      .filter(Boolean) as PharmacistProfile[];
    return mapped;
  }, [serviceUsersByCompany]);

  const rooms = useMemo(() => {
    return extractRoomsFromResources(resources);
  }, [resources]);

  const roomNames = useMemo(() => {
    return getRoomNames(rooms);
  }, [rooms]);

  const getRoomResources = (resources: any[]) => {
    return resources.filter((resource) => resource.resourceType === 2);
  };
  const roomInventory = getRoomResources(resources);

  // Selected service for dynamic rooms in booking modal
  const [selectedServiceIdForRooms, setSelectedServiceIdForRooms] = useState<
    string | undefined
  >(undefined);

  const serviceRooms = useMemo(() => {
    const rooms = appointmentRooms?.appointMentRooms;

    if (!Array.isArray(rooms)) return [];

    return rooms
      .map((room: any) => {
        const id = String(room?.roomId ?? "");
        const name = String(room?.roomName ?? "");
        return id && name ? { id, name } : null;
      })
      .filter(Boolean);
  }, [appointmentRooms]);

  const formatDurationLabel = (minutes: number) => {
    if (minutes < 60) return `${minutes} minutes`;
    const hours = minutes / 60;
    // Show ".5" for half hours, otherwise show as integer
    return hours % 1 === 0
      ? `${hours} hour${hours > 1 ? "s" : ""}`
      : `${hours} hours`;
  };

  const serviceDurations = useMemo(() => {
    if (!selectedServiceIdForRooms)
      return [] as { value: string; label: string }[];
    const svc = (defaultPharmacyServices || []).find(
      (s: any) => String(s?._id) === String(selectedServiceIdForRooms),
    );
    const base = parseInt(String((svc as any)?.serviceDuration ?? 0), 10) || 0;
    if (base <= 0) {
      // Return static list if base is 0
      const staticDurations = [15, 20, 30, 45, 60, 90, 120];
      return staticDurations.map((m) => ({
        value: String(m),
        label: formatDurationLabel(m),
      }));
    }
    const slots = Array.from({ length: 5 }, (_, i) => base * (i + 1));
    return slots.map((m) => ({
      value: String(m),
      label: formatDurationLabel(m),
    }));
  }, [selectedServiceIdForRooms, defaultPharmacyServices]);

  const serviceTypes = useMemo(() => {
    return extractServiceTypesFromServices(defaultPharmacyServices);
  }, [defaultPharmacyServices]);

  const serviceTypesInfo = useMemo(() => {
    return extractServiceTypesInfo(defaultPharmacyServices);
  }, [defaultPharmacyServices]);

  const serviceColorsFromData = useMemo(() => {
    return getServiceColorsFromData(defaultPharmacyServices, isDarkMode);
  }, [defaultPharmacyServices, isDarkMode]);

  // Block-outs from API (remote) + locally added (optimistic)
  const remoteBlockOuts = useMemo(
    () => transformAPIEventsToBlockOuts(effectiveScheduleEvents, resources),
    [effectiveScheduleEvents, resources],
  );
  const [localBlockOutAdds, setLocalBlockOutAdds] = useState<BlockOut[]>([]);
  const [localBlockOutUpdates, setLocalBlockOutUpdates] = useState<
    Record<string, BlockOut>
  >({});
  const [localBlockOutDeletes, setLocalBlockOutDeletes] = useState<Set<string>>(
    new Set(),
  );
  const mergedBlockOuts = useMemo(() => {
    const byId = new Map<string, BlockOut>();
    // start with remote
    remoteBlockOuts.forEach((bo) => {
      if (!localBlockOutDeletes.has(bo.id)) byId.set(bo.id, bo);
    });
    // apply updates
    Object.keys(localBlockOutUpdates).forEach((id) => {
      const upd = localBlockOutUpdates[id];
      if (!localBlockOutDeletes.has(id)) byId.set(id, upd);
    });
    // apply local additions
    localBlockOutAdds.forEach((bo) => {
      if (!localBlockOutDeletes.has(bo.id)) byId.set(bo.id, bo);
    });

    const list = Array.from(byId.values());
    list.sort((a, b) => {
      const dateCompare = a.startDate.localeCompare(b.startDate);
      if (dateCompare !== 0) return dateCompare;
      return a.startTime.localeCompare(b.startTime);
    });

    return list;
  }, [
    remoteBlockOuts,
    localBlockOutAdds,
    localBlockOutUpdates,
    localBlockOutDeletes,
  ]);

  const getBlockOutPharmacyId = useCallback(
    (blockOutId: string) => {
      const localAdded = localBlockOutAdds.find((b) => b.id === blockOutId);
      const localUpdated = localBlockOutUpdates[blockOutId];
      const remote = remoteBlockOuts.find((b) => b.id === blockOutId);
      const blockOut = localAdded || localUpdated || remote;
      return (
        String(blockOut?.otherPharmacyId || currentPharmacyId).trim() ||
        currentPharmacyId
      );
    },
    [
      currentPharmacyId,
      localBlockOutAdds,
      localBlockOutUpdates,
      remoteBlockOuts,
    ],
  );

  useEffect(() => {
    setLocalAdds([]);
    setLocalUpdates({});
    setLocalDeletes(new Set());
  }, [scheduleEvents, resources]);

  // When remote data eventually includes an optimistically-added block-out, remove the local copy
  useEffect(() => {
    if (!localBlockOutAdds.length) return;
    const remoteIds = new Set(remoteBlockOuts.map((b) => b.id));
    const toRemove = localBlockOutAdds
      .filter((b) => remoteIds.has(b.id))
      .map((b) => b.id);
    if (toRemove.length) {
      setLocalBlockOutAdds((prev) => prev.filter((b) => !remoteIds.has(b.id)));
    }
  }, [remoteBlockOuts, localBlockOutAdds]);

  // filters
  const filteredBookings = useMemo(() => {
    return mergedBookings.filter((b) => {
      const pharmacistMatch =
        selectedPharmacists.length === 0 ||
        selectedPharmacists.includes(b.pharmacist);

      const serviceMatch =
        selectedServiceTypes.length === 0 ||
        selectedServiceTypes.includes(b.serviceId);

      const roomMatch =
        selectedRooms.length === 0 ||
        (b.room && selectedRooms.includes(b.room));

      return pharmacistMatch && serviceMatch && roomMatch;
    });
  }, [
    mergedBookings,
    selectedPharmacists,
    selectedServiceTypes,
    selectedRooms,
  ]);

  // Normalize names for consistent comparisons (case/whitespace-insensitive)
  const normalizeName = (s?: string) =>
    String(s || "")
      .trim()
      .toLowerCase();

  const filteredBlockOuts = useMemo(() => {
    return mergedBlockOuts.filter((bo) => {
      const typeOk =
        selectedBlockOutTypes.length === 0 ||
        selectedBlockOutTypes.includes(bo.type);
      if (!typeOk) return false;

      const pharmOk =
        selectedPharmacists.length === 0 ||
        (Array.isArray(bo.affectedPharmacists) &&
          bo.affectedPharmacists.some((ap) =>
            selectedPharmacists.some(
              (sp) => normalizeName(ap) === normalizeName(sp),
            ),
          ));

      const roomOk =
        selectedRooms.length === 0 ||
        (Array.isArray(bo.affectedRooms) &&
          bo.affectedRooms.some((ar) =>
            selectedRooms.some((sr) => normalizeName(ar) === normalizeName(sr)),
          ));

      return pharmOk && roomOk;
    });
  }, [
    mergedBlockOuts,
    selectedBlockOutTypes,
    selectedPharmacists,
    selectedRooms,
  ]);

  // helpers for filtered access
  const getFilteredBookingsForDate = (date: string) =>
    getBookingsForDate(filteredBookings, date);

  const getFilteredBookingsForTimeSlot = (date: string, hour: number) =>
    getBookingsForTimeSlot(filteredBookings, date, hour);

  const getFilteredBlockOutsForDate = (date: string) =>
    getBlockOutsForDate(filteredBlockOuts, date);

  const getFilteredBlockOutsForTimeSlot = (date: string, hour: number) =>
    getBlockOutsForTimeSlot(filteredBlockOuts, date, hour);

  // UI helpers
  const getDaysInMonth = (date: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();

    const days: (number | null)[] = [];
    for (let i = 0; i < startingDayOfWeek; i++) days.push(null);
    for (let d = 1; d <= daysInMonth; d++) days.push(d);
    return days;
  };

  const getWeekDays = (date: Date) => {
    const startOfWeek = new Date(date);
    const day = startOfWeek.getDay();
    const diff = startOfWeek.getDate() - day;
    startOfWeek.setDate(diff);

    const weekDays: Date[] = [];
    for (let i = 0; i < 7; i++) {
      const d = new Date(startOfWeek);
      d.setDate(startOfWeek.getDate() + i);
      weekDays.push(d);
    }
    return weekDays;
  };

  const navigate = (direction: "prev" | "next") => {
    setCurrentDate((prev) => {
      const nd = new Date(prev);
      if (view === "month") {
        nd.setMonth(prev.getMonth() + (direction === "prev" ? -1 : 1));
      } else if (view === "week") {
        nd.setDate(prev.getDate() + (direction === "prev" ? -7 : 7));
      } else {
        nd.setDate(prev.getDate() + (direction === "prev" ? -1 : 1));
      }
      return nd;
    });
  };

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const getViewTitle = () => {
    if (view === "month") {
      return `${
        monthNames[currentDate.getMonth()]
      } ${currentDate.getFullYear()}`;
    }
    if (view === "week") {
      const weekDays = getWeekDays(currentDate);
      const start = weekDays[0];
      const end = weekDays[6];
      if (start.getMonth() === end.getMonth()) {
        return `${
          monthNames[start.getMonth()]
        } ${start.getDate()}-${end.getDate()}, ${start.getFullYear()}`;
      }
      return `${monthNames[start.getMonth()]} ${start.getDate()} - ${
        monthNames[end.getMonth()]
      } ${end.getDate()}, ${start.getFullYear()}`;
    }
    return `${
      monthNames[currentDate.getMonth()]
    } ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  };

  // actions (calendar/select)
  const onCalendarSelect = (date?: Date) => {
    if (!date) return;
    setCalendarSelectedDate(date);
    setCurrentDate(date);
    setView("day");
  };

  const handleViewDay = (dateString: string) => {
    setCurrentDate(new Date(dateString));
    setView("day");
  };

  // actions (filters)
  const handleServiceTypeChange = (serviceType: string, checked: boolean) => {
    setSelectedServiceTypes((prev) =>
      checked ? [...prev, serviceType] : prev.filter((t) => t !== serviceType),
    );
  };

  const handlePharmacistChange = (pharmacist: string, checked: boolean) => {
    setSelectedPharmacists((prev) =>
      checked ? [...prev, pharmacist] : prev.filter((p) => p !== pharmacist),
    );
  };

  const handlePharmacyChange = (pharmacyId: string, checked: boolean) => {
    setSelectedPharmacies((prev) =>
      checked ? [...prev, pharmacyId] : prev.filter((id) => id !== pharmacyId),
    );
  };

  const handleSelectAllPharmacies = (checked: boolean) =>
    setSelectedPharmacies(
      checked === true
        ? pharmacies.map((p: any) => String(p.teamPharmacyID || p.id || ""))
        : [],
    );

  const handleSelectAllServices = (checked: boolean) =>
    setSelectedServiceTypes(
      checked ? serviceTypesInfo.map((s) => s._id || s.name) : [],
    );

  const handleSelectAllPharmacists = (checked: boolean) =>
    setSelectedPharmacists(checked ? pharmacists.map((p) => p.name) : []);

  const handleRoomChange = (room: string, checked: boolean) => {
    setSelectedRooms((prev) =>
      checked ? [...prev, room] : prev.filter((r) => r !== room),
    );
  };

  const handleSelectAllRooms = (checked: boolean) =>
    setSelectedRooms(checked ? [...roomNames] : []);

  const handleBlockOutTypeChange = (type: string, checked: boolean) =>
    setSelectedBlockOutTypes((prev) =>
      checked ? [...prev, type] : prev.filter((t) => t !== type),
    );

  const handleSelectAllBlockOutTypes = (checked: boolean) =>
    setSelectedBlockOutTypes(checked ? blockOutTypes.map((t) => t.value) : []);

  // Past date/time helper
  const isDateTimeInPast = (date: string, time: string) => {
    const dt = parse(`${date} ${time}`, "yyyy-MM-dd HH:mm", new Date());
    return dt.getTime() < Date.now();
  };

  // Check time overlap
  const isOverlap = (startA: Date, endA: Date, startB: Date, endB: Date) => {
    return startA < endB && endA > startB;
  };

  // Room conflict detection using current merged bookings (accepts id or name)
  const hasRoomConflict = (
    date: string,
    time: string,
    duration: number,
    roomSelector?: string,
    excludeBookingId?: string,
  ): boolean => {
    if (!roomSelector) return false;
    const start = parse(`${date} ${time}`, "yyyy-MM-dd HH:mm", new Date());
    const end = addMinutes(start, Number(duration));

    const selectorId = rooms.find((r) => String(r.id) === String(roomSelector))
      ?.id;
    const selectorName = rooms.find(
      (r) => normalizeName(r.name) === normalizeName(roomSelector),
    )?.name;

    return mergedBookings.some((b) => {
      if (b.date !== date) return false;
      if (excludeBookingId && b.id === excludeBookingId) return false;

      const byId =
        b.roomId &&
        (b.roomId === roomSelector || (selectorId && b.roomId === selectorId));
      const byName =
        b.room &&
        (normalizeName(b.room) === normalizeName(roomSelector) ||
          (selectorName &&
            normalizeName(b.room) === normalizeName(selectorName)));
      if (!byId && !byName) return false;

      const [bh, bm] = (b.time || "00:00").split(":");
      const bStart = parse(
        `${b.date} ${bh}:${bm}`,
        "yyyy-MM-dd HH:mm",
        new Date(),
      );
      const bEnd = addMinutes(bStart, Number(b.duration || 0));
      return isOverlap(start, end, bStart, bEnd);
    });
  };

  // True if the pharmacist already has a non-cancelled booking or a block-out overlapping the slot.
  const isPharmacistBookedAtSlot = useCallback(
    (
      date: string,
      time: string,
      duration: number,
      pharmacist: { id?: string; name?: string },
    ) => {
      if (!date || !time || !duration) return false;
      const norm = (v?: string) =>
        String(v || "")
          .trim()
          .toLowerCase();
      const toMinutes = (t: string) => {
        const [h, m] = String(t || "00:00").split(":");
        return parseInt(h || "0", 10) * 60 + parseInt(m || "0", 10);
      };
      const start = toMinutes(time);
      const end = start + Number(duration);
      const pid = norm(pharmacist?.id);
      const pname = norm(pharmacist?.name);

      const bookedByAppointment = mergedBookings.some((b) => {
        if (b.date !== date || b.eventStatus === 4) return false;
        const idMatch =
          pid &&
          [b.pharmacistId, b.resourceId].some((v) => v && norm(v) === pid);
        const nameMatch = pname && norm(b.pharmacist) === pname;
        if (!idMatch && !nameMatch) return false;
        const bStart = toMinutes(b.time);
        const bEnd = bStart + Number(b.duration || 0);
        return start < bEnd && end > bStart;
      });
      if (bookedByAppointment) return true;

      // Block-outs repeat the same time-of-day window on every day in their range.
      return mergedBlockOuts.some((bo: any) => {
        const boStartDate = bo.startDate || bo.date || "";
        const boEndDate = bo.endDate || boStartDate;
        if (!boStartDate || date < boStartDate || date > boEndDate)
          return false;

        const affected: string[] = Array.isArray(bo.affectedPharmacists)
          ? bo.affectedPharmacists.map((p: any) => norm(p))
          : [];
        const affectsPharmacist = affected.some((boP) => {
          if ((pid && boP === pid) || (pname && boP === pname)) return true;
          const res = (resources || []).find(
            (r: any) =>
              norm(String(r.id || r._id || "")) === boP || norm(r.name) === boP,
          );
          return Boolean(
            res &&
              ((pid && norm(String(res.id || res._id || "")) === pid) ||
                (pname && norm(res.name) === pname)),
          );
        });
        if (!affectsPharmacist) return false;

        const boStart = toMinutes(bo.startTime || "00:00");
        const boEnd = toMinutes(bo.endTime || "23:59");
        return start < boEnd && end > boStart;
      });
    },
    [mergedBookings, mergedBlockOuts, resources],
  );

  // Pharmacist conflict detection using current merged bookings (by name)
  const hasPharmacistConflict = (
    date: string,
    time: string,
    duration: number,
    pharmacistName?: string,
    excludeBookingId?: string,
  ): boolean => {
    if (!pharmacistName) return false;
    const start = parse(`${date} ${time}`, "yyyy-MM-dd HH:mm", new Date());
    const end = addMinutes(start, Number(duration));
    const nPharm = normalizeName(pharmacistName);
    return mergedBookings.some((b) => {
      if (b.date !== date) return false;
      if (
        excludeBookingId &&
        (String(b.id) === String(excludeBookingId) ||
          String((b as any)._id) === String(excludeBookingId))
      ) {
        return false;
      }

      const bPharmNorm = normalizeName(b.pharmacist);
      let isMatch = bPharmNorm === nPharm;
      if (!isMatch) {
        const res = (resources || []).find(
          (r: any) =>
            String(r.id || r._id).toLowerCase() === nPharm ||
            normalizeName(r.name) === nPharm,
        );
        if (res) {
          isMatch =
            String(res.id || res._id).toLowerCase() === bPharmNorm ||
            normalizeName(res.name) === bPharmNorm;
        }
      }
      if (!isMatch) return false;

      const [bh, bm] = (b.time || "00:00").split(":");
      const bStart = parse(
        `${b.date} ${bh}:${bm}`,
        "yyyy-MM-dd HH:mm",
        new Date(),
      );
      const bEnd = addMinutes(bStart, Number(b.duration || 0));
      return isOverlap(start, end, bStart, bEnd);
    });
  };

  // Check if an appointment overlaps with any block-out for a given pharmacist or room
  // Enhanced conflict detection that properly handles full-day block-outs
  const hasBlockOutConflictForBooking = (
    date: string,
    time: string,
    duration: number,
    pharmacistName?: string,
    roomName?: string,
  ): boolean => {
    const start = parse(`${date} ${time}`, "yyyy-MM-dd HH:mm", new Date());
    const end = addMinutes(start, Number(duration));

    const nRoom = normalizeName(roomName);
    const nPharm = normalizeName(pharmacistName);

    return mergedBlockOuts.some((bo: any) => {
      const boStartDate =
        bo.startDate || bo.date || (bo as any).StartDate || "";
      const boEndDate =
        bo.endDate || bo.startDate || bo.date || (bo as any).EndDate || "";

      if (!boStartDate) return false;

      // Check if the appointment date is within block-out date range
      if (date < boStartDate || date > boEndDate) {
        return false;
      }

      // The backend stores a multi-day block-out as one row per day, each covering
      // the SAME time-of-day window (see BlockEventSplitter.SplitIntoDailyBlocks) -
      // e.g. 14-16 Oct 10:00-12:00 blocks 10:00-12:00 on each of those three days,
      // not the whole of the first/last day. So every day in range uses the same
      // effective start/end time; an all-day block simply has no explicit times set
      // and falls back to the full 00:00-23:59 window below.
      const effectiveStartTime = bo.startTime || "00:00";
      const effectiveEndTime = bo.endTime || "23:59";

      // Parse block-out start and end times for the specific date
      const boStart = parse(
        `${date} ${effectiveStartTime}`,
        "yyyy-MM-dd HH:mm",
        new Date(),
      );
      const boEnd = parse(
        `${date} ${effectiveEndTime}`,
        "yyyy-MM-dd HH:mm",
        new Date(),
      );

      // Check if appointment overlaps with block-out
      const overlaps = isOverlap(start, end, boStart, boEnd);
      if (!overlaps) return false;

      const roomList: string[] = Array.isArray(bo.affectedRooms)
        ? bo.affectedRooms.map((r: any) => normalizeName(r))
        : [];
      const pharmList: string[] = Array.isArray(bo.affectedPharmacists)
        ? bo.affectedPharmacists.map((p: any) => normalizeName(p))
        : [];

      // Handle block-outs with no specific resources (global block)
      if (roomList.length === 0 && pharmList.length === 0) {
        return true;
      }

      let affectsRoom = false;
      if (nRoom) {
        affectsRoom = roomList.some((boR) => {
          if (boR === nRoom) return true;
          const rObj = (resources || []).find(
            (r: any) =>
              String(r.id || r._id).toLowerCase() === boR ||
              normalizeName(r.name) === boR,
          );
          if (rObj) {
            return (
              String(rObj.id || rObj._id).toLowerCase() === nRoom ||
              normalizeName(rObj.name) === nRoom
            );
          }
          return false;
        });
      }

      let affectsPharmacist = false;
      if (nPharm) {
        affectsPharmacist = pharmList.some((boP) => {
          if (boP === nPharm) return true;
          const pObj = (resources || []).find(
            (r: any) =>
              String(r.id || r._id).toLowerCase() === boP ||
              normalizeName(r.name) === boP,
          );
          if (pObj) {
            return (
              String(pObj.id || pObj._id).toLowerCase() === nPharm ||
              normalizeName(pObj.name) === nPharm
            );
          }
          return false;
        });
      }

      return Boolean(affectsRoom || affectsPharmacist);
    });
  };

  // Check if a block-out overlaps any existing appointment for selected pharmacists/rooms
  const hasEventConflictForBlockOut = (
    date: string,
    startTime: string,
    endTime: string,
    selectedPharmacists: string[] = [],
    selectedRooms: string[] = [],
  ): boolean => {
    const boStart = parse(
      `${date} ${startTime}`,
      "yyyy-MM-dd HH:mm",
      new Date(),
    );
    const boEnd = parse(`${date} ${endTime}`, "yyyy-MM-dd HH:mm", new Date());

    const nRooms = (selectedRooms || []).map((r) => normalizeName(r));
    const nPharms = (selectedPharmacists || []).map((p) => normalizeName(p));

    return mergedBookings.some((b) => {
      if (b.date !== date) return false;
      const bStart = parse(
        `${b.date} ${b.time || "00:00"}`,
        "yyyy-MM-dd HH:mm",
        new Date(),
      );
      const bEnd = addMinutes(bStart, Number(b.duration || 0));
      if (!isOverlap(boStart, boEnd, bStart, bEnd)) return false;

      // 👇 If no specific resources selected, block ALL appointments
      if (nRooms.length === 0 && nPharms.length === 0) {
        return true;
      }

      const roomMatches = b.room && nRooms.includes(normalizeName(b.room));
      const pharmacistMatches =
        b.pharmacist && nPharms.includes(normalizeName(b.pharmacist));
      return Boolean(roomMatches || pharmacistMatches);
    });
  };
  const isDateFullyBlocked = (date: string): boolean => {
    return mergedBlockOuts.some((bo) => {
      // Check if date is within block-out range
      if (date < bo.startDate || date > bo.endDate) return false;

      // Check if this block-out should block the entire day
      const roomList = Array.isArray(bo.affectedRooms) ? bo.affectedRooms : [];
      const pharmList = Array.isArray(bo.affectedPharmacists)
        ? bo.affectedPharmacists
        : [];

      // If no specific resources, this block-out affects everyone
      const isGlobalBlock = roomList.length === 0 && pharmList.length === 0;

      if (!isGlobalBlock) return false;

      // Check if this date is fully covered
      if (date > bo.startDate && date < bo.endDate) {
        // Middle date - always fully blocked
        return true;
      }

      if (date === bo.startDate && date === bo.endDate) {
        // Single day block-out - check if it covers full day
        return bo.startTime === "00:00" && bo.endTime === "23:59";
      }

      if (date === bo.startDate && bo.startTime === "00:00") {
        // First day starting at midnight
        return true;
      }

      if (date === bo.endDate && bo.endTime === "23:59") {
        // Last day ending at midnight
        return true;
      }

      return false;
    });
  };
  // Check for conflicts against existing block-outs (same date/time overlap and intersects rooms/pharmacists), excluding a given block-out id
  const hasBlockOutConflictForBlockOut = (
    date: string,
    startTime: string,
    endTime: string,
    selectedPharmacists: string[] = [],
    selectedRooms: string[] = [],
    excludeBlockOutId?: string,
  ): boolean => {
    const boStart = parse(
      `${date} ${startTime}`,
      "yyyy-MM-dd HH:mm",
      new Date(),
    );
    const boEnd = parse(`${date} ${endTime}`, "yyyy-MM-dd HH:mm", new Date());
    const nRooms = (selectedRooms || []).map((r) => normalizeName(r));
    const nPharms = (selectedPharmacists || []).map((p) => normalizeName(p));

    return mergedBlockOuts.some((bo) => {
      if (excludeBlockOutId && bo.id === excludeBlockOutId) return false;
      if (date < bo.startDate || date > bo.endDate) return false;
      const otherStart = parse(
        `${date} ${bo.startTime}`,
        "yyyy-MM-dd HH:mm",
        new Date(),
      );
      const otherEnd = parse(
        `${date} ${bo.endTime}`,
        "yyyy-MM-dd HH:mm",
        new Date(),
      );
      if (!isOverlap(boStart, boEnd, otherStart, otherEnd)) return false;

      const otherRooms = Array.isArray(bo.affectedRooms)
        ? bo.affectedRooms.map((r) => normalizeName(r))
        : [];
      const otherPharms = Array.isArray(bo.affectedPharmacists)
        ? bo.affectedPharmacists.map((p) => normalizeName(p))
        : [];

      // 👇 If both block-outs have no specific resources, they conflict
      if (
        nRooms.length === 0 &&
        nPharms.length === 0 &&
        otherRooms.length === 0 &&
        otherPharms.length === 0
      ) {
        return true;
      }

      const roomsIntersect = nRooms.some((r) => otherRooms.includes(r));
      const pharmsIntersect = nPharms.some((p) => otherPharms.includes(p));
      return roomsIntersect || pharmsIntersect;
    });
  };
  const createVaccineDraftFromSchedule = async (
    vaccines: any[],
    consultationID: string,
  ) => {
    const draftData = {
      vaccineItems: vaccines.map((v) => ({
        vaccineName: v.vaccineName,
        dose: "",
        schedule: v.schedule || "As per schedule",
        notes: v.notes,
        route: v.route || "IM / SC",
        site: v.site || "Deltoid - left / right",
      })),
      timestamp: new Date().toISOString(),
    };

    const payload = {
      payload: JSON.stringify(draftData),
      actionName: "CreateVaccineDraft",
      actionNumber: "12",
      isPerformed: true,
      performedAt: new Date().toISOString(),
      draftStatus: DraftStatus.Pending,
    };

    await updateConsultationActions({
      consultationId: consultationID,
      payload,
    });

    return {
      sender: "success",
      message: "Vaccine draft created.",
      actionId: 12,
      details: payload,
    };
  };
  const createTaskDraftFromSchedule = async (
    tasks: any[],
    consultationID: string,
  ) => {
    const draftData = {
      tasks: tasks.map((t) => ({
        label: t,
        completed: false,
      })),
      timestamp: new Date().toLocaleString(),
    };

    const payload = {
      payload: JSON.stringify(draftData),
      actionName: "CreateTask",
      actionNumber: "14",
      isPerformed: true,
      performedAt: new Date().toLocaleString(),
      draftStatus: DraftStatus.Pending,
    };

    await updateConsultationActions({
      consultationId: consultationID,
      payload,
    });

    return {
      sender: "success",
      message: "Task created.",
      actionId: 14,
      details: payload,
    };
  };
  const onCreateBooking = useCallback(
    async (bookingData: any) => {
      const {
        date,
        time,
        duration,
        patientName,
        serviceType,
        pharmacist,
        notes,
        patientId,
        room,
        email,
        mobile,
        confirmationMethod,
        tasksToComplete,
        vaccinesAdminister,
      } = bookingData;
      if (isDateFullyBlocked(date)) {
        throw new Error(
          "Cannot create appointment. This date is fully blocked. Please select another date.",
        );
      }

      let roomNameForConflict = room;
      if (room && room.match(/^[0-9a-fA-F]{24}$/)) {
        const foundRoom = rooms.find((r) => r.id === room);
        roomNameForConflict = foundRoom?.name || room;
      }
      const tasks = Array.isArray(tasksToComplete) ? tasksToComplete : [];
      const vaccines = Array.isArray(vaccinesAdminister)
        ? vaccinesAdminister
        : [];

      const roomIdFromSelection = rooms.find(
        (rp) => normalizeName(rp.name) === normalizeName(room),
      )?.id;
      const bookingDataForLog = {
        ...bookingData,
        room: roomIdFromSelection || room,
      };

      const gmtDate = parse(`${date} ${time}`, "yyyy-MM-dd HH:mm", new Date());
      const startDate = new Date(
        gmtDate.getTime() - gmtDate.getTimezoneOffset() * 60000,
      );

      const parsedEnd = addMinutes(startDate, parseInt(duration));

      // Disallow creating appointments in the past
      if (isDateTimeInPast(date, time)) {
        throw new Error(
          "Cannot create appointments in the past. Please choose a future date and time.",
        );
      }
      // Block-out conflict check (room or pharmacist)
      const resource = (resources || []).find(
        (r: any) => String(r.id) === String(pharmacist),
      );

      const pharmacistNameForCheck =
        resource?.name ||
        (servicePharmacists.find(
          (p: any) => String(p.id) === String(pharmacist),
        )?.name as string | undefined);

      if (
        hasBlockOutConflictForBooking(
          date,
          time,
          parseInt(duration),
          pharmacistNameForCheck,
          roomNameForConflict,
        )
      ) {
        throw new Error(
          "Cannot create appointment. A block-out exists for the selected room or pharmacist in this time range.",
        );
      }
      // Client-side room conflict check
      if (
        roomNameForConflict &&
        hasRoomConflict(date, time, parseInt(duration), roomNameForConflict)
      ) {
        throw new Error(
          "Please select another room or different time slot. This slot for the selected room is already booked or unavailable.",
        );
      }

      // Client-side pharmacist conflict check
      if (
        pharmacistNameForCheck &&
        hasPharmacistConflict(
          date,
          time,
          parseInt(duration),
          pharmacistNameForCheck,
        )
      ) {
        throw new Error(
          "Please select another pharmacist or different time slot. This slot for the selected pharmacist is already booked or unavailable.",
        );
      }

      const newId = uuidv4();
      const selectedPharmacist = servicePharmacists.find(
        (p: any) => String(p.id) === String(pharmacist),
      );
      const appointmentType =
        bookingData.appointmentType ??
        (selectedPharmacist?.isOutsideWorkingHours ? 4 : 1);
      const appointment = {
        id: newId,
        consultationID: newId,
        startDate: startDate.toISOString(),
        endDate: parsedEnd.toISOString(),
        duration: parseInt(duration),
        durationUnit: "m",
        cls: "",
        patientID: patientId,
        name: notes,
        recurrenceRule: "",
        exceptionDates: [],
        resourceId: pharmacist,
        allDay: false,
        scheduleEventType: 1,
        serviceID: serviceType,
        email: email,
        mobile: mobile,
        confirmationMethod: confirmationMethod,
        appointmentType,
        // optional fields
        ...(tasks.length ? { tasksToComplete: tasks } : {}),
        ...(vaccines.length ? { vaccinesAdminister: vaccines } : {}),
        RoomId: bookingDataForLog?.room,
        createdAt: new Date().toISOString(),
        IsNotify: true,
        ...(bookingData.pharmacist === "any" && {
          companyId: companyId,
        }),
      };

      try {
        const response = await addScheduleEvent(appointment, currentPharmacyId);
        const chatMessages: any[] = [];
        if (showMyAppointmentsOnly) {
          await refreshMyAppointmentsSilently();
        }
        if (appointment.vaccinesAdminister?.length) {
          const vaccineChat = await createVaccineDraftFromSchedule(
            appointment.vaccinesAdminister,
            appointment.consultationID,
          );

          if (vaccineChat) chatMessages.push(vaccineChat);
        }

        if (appointment.tasksToComplete?.length) {
          const taskChat = await createTaskDraftFromSchedule(
            appointment.tasksToComplete,
            appointment.consultationID,
          );

          if (taskChat) chatMessages.push(taskChat);
        }

        if (chatMessages.length) {
          await SaveAIChatMessage({
            consultationChat: JSON.stringify(chatMessages),
            consultationId: appointment.consultationID,
          });
        }

        if (bookingSlotsMode === "fromAppointment") {
          const appointmentPayload = {
            payload: JSON.stringify(appointment),
            actionName: ActionType[4],
            actionNumber: "4",
            isPerformed: true,
          };

          if (consultationId !== "") {
            updateConsultationActions({
              consultationId: consultationId === "" ? newId : consultationId,
              payload: appointmentPayload,
            });
            const appointmentMessage = [
              {
                sender: "success",
                message: "Booking completed successfully.",
                actionId: 4,
                details: appointmentPayload,
              },
            ];
            await SaveAIChatMessage({
              ConsultationChat: JSON.stringify(appointmentMessage),
              ConsultationId: consultationId,
            });

            setAddPatientAIChatMessage({
              sender: "success",
              message: "Booking completed successfully.",
              actionId: 4,
              details: appointmentPayload,
            });

            setBookingDetails(appointmentPayload);
            removeActionFromLocal(consultationId, "4");
            setIncrementBookingCompleted(true);
          }
          if (consultationId !== "") {
            try {
              trackServiceBilling({
                companyId,
                consultationId: consultationId,
                pharmacyId: currentPharmacyId,
                actiontype: "appointment",
              });
            } catch (err) {
              console.error(
                "Error calling billing tracker for appointment:",
                err,
              );
            }
          }
        }

        // Optimistically add to local state without refetch
        const resource = (resources || []).find(
          (r: any) =>
            r.id ===
            (pharmacist === "any" ? response?.resourceName : pharmacist),
        );
        const service = (defaultPharmacyServices || []).find(
          (s: any) => s._id === serviceType,
        );
        const serviceName = service?.serviceName || "";
        const pharmacistName =
          resource?.name ||
          pharmacistIdToName.get(String(pharmacist)) ||
          (pharmacist && pharmacist !== "any" ? String(pharmacist) : "") ||
          "";
        const booking: Booking = {
          id: newId,
          consultationID: newId,
          patientName: patientName,
          pharmacist: pharmacistName,
          pharmacistId:
            pharmacist && pharmacist !== "any" ? String(pharmacist) : undefined,
          resourceId:
            pharmacist && pharmacist !== "any" ? String(pharmacist) : undefined,
          serviceType: SERVICE_TYPE_MAPPING[serviceName] || "Covid",
          serviceName: serviceName,
          serviceId: service?._id || serviceType,
          date,
          time,
          duration: parseInt(duration),
          room: room || undefined,
          roomId: bookingDataForLog?.room || undefined,
          notes: notes,
          status: "confirmed",
          contactNumber: String(bookingData?.mobile ?? ""),
          email: String(bookingData?.email ?? ""),
          confirmationMethod:
            bookingData?.confirmationMethod === "email" ||
            bookingData?.confirmationMethod === "mobile"
              ? bookingData.confirmationMethod
              : undefined,
          patientId: patientId,
          tasksToComplete,
          vaccinesAdminister,
          otherPharmacyId: currentPharmacyId,
          otherPharmacyName:
            (pharmacies || []).find(
              (p: any) =>
                String(p.teamPharmacyID || p.id) === String(currentPharmacyId),
            )?.teamPharmacyName || undefined,
        };
        if (response) {
          setLocalAdds((prev) => [...prev, booking]);
        }
        setModalState({ isOpen: false, mode: null });
      } catch (e) {
        console.error(e);
        throw e as any;
      }
    },
    [
      currentPharmacyId,
      resources,
      defaultPharmacyServices,
      mergedBookings,
      mergedBlockOuts,
      servicePharmacists,
    ],
  );

  const onShowEditBooking = useCallback(
    (bookingId: string, booking: Booking) => {
      setModalState({ isOpen: true, mode: "edit", booking });
      setOtherPharmacyIdForBooking(
        String(
          booking?.otherPharmacyId ||
            (booking as any)?.PharmacyID ||
            (booking as any)?.OtherPharmacyId ||
            "",
        ).trim() || currentPharmacyId,
      );
    },
    [currentPharmacyId],
  );

  const onEditBooking = useCallback(
    async (bookingId: string, bookingData: any) => {
      const {
        date,
        time,
        duration,
        patientName,
        serviceType,
        pharmacist,
        patientId,
        notes,
        room,
        email,
        mobile,
        confirmationMethod,
        tasksToComplete,
        vaccinesAdminister,
      } = bookingData;
      const tasks = Array.isArray(tasksToComplete) ? tasksToComplete : [];
      const vaccines = Array.isArray(vaccinesAdminister)
        ? vaccinesAdminister
        : [];

      const roomIdFromSelection = rooms.find(
        (rp) => normalizeName(rp.name) === normalizeName(room),
      )?.id;
      const bookingDataForLog = {
        ...bookingData,
        room: roomIdFromSelection || room,
      };
      // For debugging requested: log with room id instead of name when available

      const gmtDate = parse(`${date} ${time}`, "yyyy-MM-dd HH:mm", new Date());
      const startDate = new Date(
        gmtDate.getTime() - gmtDate.getTimezoneOffset() * 60000,
      );
      const parsedEnd = addMinutes(startDate, parseInt(duration));

      // Block-out conflict check (room or pharmacist) for edit
      const resource = (resources || []).find(
        (r: any) => String(r.id) === String(pharmacist),
      );
      const pharmacistNameForCheck =
        resource?.name ||
        (servicePharmacists.find(
          (p: any) => String(p.id) === String(pharmacist),
        )?.name as string | undefined);
      const existing = mergedBookings.find((b) => b.id === bookingId);
      const hasChanged =
        !existing ||
        existing.date !== date ||
        existing.time !== time ||
        existing.duration !== parseInt(duration) ||
        normalizeName(existing.room || "") !== normalizeName(room || "") ||
        normalizeName(existing.pharmacist || "") !==
          normalizeName(pharmacistNameForCheck || "");
      if (hasChanged) {
        // Block-out conflict check (room or pharmacist) for edit
        if (isDateFullyBlocked(date)) {
          throw new Error(
            "Cannot update appointment. This date is fully blocked. Please select another date.",
          );
        }
        if (
          hasBlockOutConflictForBooking(
            date,
            time,
            parseInt(duration),
            pharmacistNameForCheck,
            room,
          )
        ) {
          throw new Error(
            "Cannot update appointment. A block-out exists for the selected room or pharmacist in this time range.",
          );
        }

        // Client-side room conflict check, excluding this booking id
        if (
          room &&
          hasRoomConflict(date, time, parseInt(duration), room, bookingId)
        ) {
          throw new Error(
            "Please select another room or different time slot. This slot for the selected room is already booked or unavailable.",
          );
        }

        // Client-side pharmacist conflict check, excluding this booking id
        if (
          pharmacistNameForCheck &&
          hasPharmacistConflict(
            date,
            time,
            parseInt(duration),
            pharmacistNameForCheck,
            bookingId,
          )
        ) {
          throw new Error(
            "Please select another pharmacist or different time slot. This slot for the selected pharmacist is already booked or unavailable.",
          );
        }
      }

      const existingForEdit = mergedBookings.find((b) => b.id === bookingId);
      const sourceBooking =
        existingForEdit || (modalState?.booking as Booking | undefined);
      const selectedPharmacist = servicePharmacists.find(
        (p: any) => String(p.id) === String(pharmacist),
      );
      const appointmentType =
        bookingData.appointmentType ??
        (selectedPharmacist?.isOutsideWorkingHours ? 4 : 1);
      const appointment = {
        id: bookingId,
        consultationID: sourceBooking?.consultationID || bookingId,
        startDate: startDate.toISOString(),
        endDate: parsedEnd.toISOString(),
        duration: parseInt(duration),
        durationUnit: "m",
        cls: "",
        patientID: patientId,
        name: notes,
        recurrenceRule: "",
        exceptionDates: [],
        resourceId: pharmacist,
        allDay: false,
        scheduleEventType: 1,
        serviceID: serviceType,
        email: email,
        mobile: mobile,
        confirmationMethod: confirmationMethod,
        appointmentType,
        RoomId: roomIdFromSelection || room || "",
        IsNotify:
          typeof bookingData?.IsNotify === "boolean"
            ? bookingData.IsNotify
            : true,
        ...(tasks.length ? { tasksToComplete: tasks } : {}),
        ...(vaccines.length ? { vaccinesAdminister: vaccines } : {}),
        ...(bookingData.pharmacist === "any" && {
          companyId: companyId,
        }),
      };
      const targetPharmacyId =
        String(
          bookingData?.otherPharmacyId || sourceBooking?.otherPharmacyId || "",
        ).trim() || currentPharmacyId;
      try {
        const response = await addScheduleEvent(appointment, targetPharmacyId);
        if (showMyAppointmentsOnly) {
          await refreshMyAppointmentsSilently();
        }

        const chatMessages: any[] = [];
        const consultationIDForDrafts =
          existingForEdit?.consultationID || bookingId;

        // Create vaccine draft if vaccines exist
        if (appointment.vaccinesAdminister?.length) {
          const vaccineChat = await createVaccineDraftFromSchedule(
            appointment.vaccinesAdminister,
            consultationIDForDrafts,
          );

          if (vaccineChat) chatMessages.push(vaccineChat);
        }

        // Create task draft if tasks exist
        if (appointment.tasksToComplete?.length) {
          const taskChat = await createTaskDraftFromSchedule(
            appointment.tasksToComplete,
            consultationIDForDrafts,
          );

          if (taskChat) chatMessages.push(taskChat);
        }

        // Save AI chat messages if any
        if (chatMessages.length) {
          await SaveAIChatMessage({
            consultationChat: JSON.stringify(chatMessages),
            consultationId: consultationIDForDrafts,
          });
        }

        const resource = (resources || []).find(
          (r: any) =>
            r.id ===
            (pharmacist === "any" ? response?.resourceName : pharmacist),
        );
        const service = (defaultPharmacyServices || []).find(
          (s: any) => s._id === serviceType,
        );
        const serviceName = service?.serviceName || "";
        const existing = mergedBookings.find((b) => b.id === bookingId);
        const pharmacistName =
          resource?.name ||
          pharmacistIdToName.get(String(pharmacist)) ||
          (pharmacist && pharmacist !== "any" ? String(pharmacist) : "") ||
          existing?.pharmacist ||
          "";
        const updated: Booking = {
          id: bookingId,
          consultationID: existing?.consultationID || bookingId,
          patientName: patientName,
          pharmacist: pharmacistName,
          pharmacistId:
            pharmacist && pharmacist !== "any"
              ? String(pharmacist)
              : existing?.pharmacistId,
          resourceId:
            pharmacist && pharmacist !== "any"
              ? String(pharmacist)
              : existing?.resourceId,
          serviceType: SERVICE_TYPE_MAPPING[serviceName] || "Covid",
          serviceName: serviceName,
          serviceId: service?._id || serviceType,
          date,
          time,
          duration: parseInt(duration),
          room: room || undefined,
          roomId: bookingDataForLog?.room || existing?.roomId,
          notes: notes,
          status: "confirmed",
          contactNumber: String(bookingData?.mobile ?? ""),
          email: String(bookingData?.email ?? ""),
          confirmationMethod:
            bookingData?.confirmationMethod === "email" ||
            bookingData?.confirmationMethod === "mobile"
              ? bookingData.confirmationMethod
              : undefined,
          patientId: patientId,
          tasksToComplete,
          vaccinesAdminister,
        };
        // If it was a local add, modify it there; otherwise keep in updates map
        if (response) {
          setLocalAdds((prev) =>
            prev.map((b) => (b.id === bookingId ? updated : b)),
          );
          setLocalUpdates((prev) => ({ ...prev, [bookingId]: updated }));
        }
        setModalState({ isOpen: false, mode: null });
      } catch (e) {
        console.error(e);
        throw e as any;
      }
    },
    [
      currentPharmacyId,
      resources,
      defaultPharmacyServices,
      mergedBookings,
      mergedBlockOuts,
      servicePharmacists,
    ],
  );

  const onDeleteBooking = async (bookingId: string) => {
    try {
      const response = await deleteScheduleEvents(
        bookingId,
        otherPharmacyIdForBooking || currentPharmacyId,
      );
      setLocalDeletes((prev) => new Set(prev).add(bookingId));

      if (response) {
        if (showMyAppointmentsOnly) {
          await refreshMyAppointmentsSilently();
        }
        setLocalAdds((prev) => prev.filter((b) => b.id !== bookingId));
        setLocalUpdates((prev) => {
          const { [bookingId]: _, ...rest } = prev;
          return rest;
        });
      }
    } catch (e) {
      console.error(e);
    }
  };

  const onCreateBookingForDate = useCallback((dateString: string) => {
    setShowBacktoSlotsButton(false);
    setBookingSlotsMode(null);
    setOtherPharmacyIdForBooking(null);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const clicked = new Date(`${dateString}T00:00:00`);
    if (clicked.getTime() < today.getTime()) {
      setConflictWarning("Cannot create appointments on past dates.");
      return;
    }
    setModalState({ isOpen: true, mode: "create", initialDate: dateString });
  }, []);

  const openNewAppointment = useCallback(() => {
    setShowBacktoSlotsButton(false);
    setBookingSlotsMode(null);
    setOtherPharmacyIdForBooking(null);

    setModalState({ isOpen: true, mode: "create" });
  }, []);

  // helpers for block-out type mapping and color
  const mapBlockOutTypeToEnum = (type: string): number => {
    const t = (type || "").toLowerCase();
    switch (t) {
      case "team_event":
      case "teamevent":
        return 2; // TeamEvent
      case "training":
      case "trainingsession":
        return 3; // TrainingSession
      case "maintenance":
        return 4; // Maintenance
      case "break":
        return 5; // Break
      default:
        return 6; // Other
    }
  };
  const mapBlockOutTypeToColor = (type: string): string => {
    const t = blockOutTypes.find((x) => x.value === type);
    return t?.color || "bg-gray-500";
  };
  const buildLocalDateTime = (date: string, time: string): Date =>
    new Date(`${date}T${time}:00`);

  // actions (block outs)
  const onCreateBlockOut = async (blockOutData: any) => {
    const isAllDay = !!blockOutData?.isAllDay;
    const startDateStr = String(
      blockOutData?.startDate || blockOutData?.date || "",
    );
    const endDateStr = String(
      blockOutData?.endDate || blockOutData?.date || "",
    );

    const startTimeStr = isAllDay
      ? "00:00"
      : String(blockOutData?.startTime || "00:00");
    const endTimeStr = isAllDay
      ? "23:59"
      : String(blockOutData?.endTime || "23:59");

    const selectedRooms = Array.isArray(blockOutData?.affectedRooms)
      ? blockOutData.affectedRooms
      : [];
    const selectedPharmacists = Array.isArray(blockOutData?.affectedPharmacists)
      ? blockOutData.affectedPharmacists
      : [];
    const affectedPharmacistsForApi = selectedPharmacists.map(
      (pharmacist) =>
        pharmacistNameToId.get(
          String(pharmacist)
            .trim()
            .toLowerCase(),
        ) || pharmacist,
    );
    const affectedPharmacistsForLocal = selectedPharmacists.map(
      (pharmacist) => pharmacistIdToName.get(String(pharmacist)) || pharmacist,
    );

    const dateForCheck = String(
      blockOutData?.date || blockOutData?.startDate || startDateStr,
    );

    // Check for existing appointments
    if (
      (selectedRooms.length > 0 || affectedPharmacistsForLocal.length > 0) &&
      hasEventConflictForBlockOut(
        dateForCheck,
        startTimeStr,
        endTimeStr,
        affectedPharmacistsForLocal,
        selectedRooms,
      )
    ) {
      throw new Error(
        "Cannot create block-out. There are existing appointments for the selected room or pharmacist in this time range.",
      );
    }

    // Check for overlap with other block-outs
    if (
      hasBlockOutConflictForBlockOut(
        dateForCheck,
        startTimeStr,
        endTimeStr,
        affectedPharmacistsForLocal,
        selectedRooms,
      )
    ) {
      throw new Error(
        "Cannot create block-out. Another block-out exists for the selected room or pharmacist in this time range.",
      );
    }

    const startDate = buildLocalDateTime(startDateStr, startTimeStr);
    const endDate = buildLocalDateTime(endDateStr, endTimeStr);

    const newId = String((blockOutData as any)?.id || uuidv4());

    try {
      const payload = {
        id: newId,
        title: blockOutData?.title || "",
        type: mapBlockOutTypeToEnum(blockOutData?.type),
        startDate: format(startDate, "yyyy-MM-dd'T'HH:mm:ss'Z'"),
        endDate: format(endDate, "yyyy-MM-dd'T'HH:mm:ss'Z'"),
        description: blockOutData?.description || "",
        affectedRooms: selectedRooms,
        affectedPharmacists: affectedPharmacistsForApi,
        color: mapBlockOutTypeToColor(blockOutData?.type),
      };

      await addBlockOut(payload, currentPharmacyId);
      await refreshScheduleEventsSilently(currentPharmacyId);
      if (showMyAppointmentsOnly) {
        await refreshMyAppointmentsSilently();
      }
      // Create the base block-out object for local state
      const newBlock: BlockOut = {
        id: newId,
        title: blockOutData?.title || "",
        type: (blockOutData?.type || "other") as BlockOut["type"],
        startDate: startDateStr,
        endDate: endDateStr,
        startTime: startTimeStr,
        endTime: endTimeStr,
        description: blockOutData?.description || "",
        affectedRooms: selectedRooms,
        affectedPharmacists: affectedPharmacistsForLocal,
        isRecurring: false,
        color: mapBlockOutTypeToColor(blockOutData?.type),
      };

      // Optimistically add to local UI
      setLocalBlockOutAdds((prev) => [...prev, newBlock]);
    } catch (e) {
      // On error, remove optimistic addition
      // setLocalBlockOutAdds((prev) => prev.filter((b) => b.id !== newBlock.id));
      console.error("Failed to create block-out:", e);
      throw e;
    }
  };
  const onEditBlockOut = async (
    blockOutId: string,
    blockOutData: any,
    blockOutOtherPharmacyId?: string,
  ) => {
    const isAllDay = !!blockOutData?.isAllDay;
    const startDateStr = String(
      blockOutData?.startDate || blockOutData?.date || "",
    );
    const endDateStr = String(
      blockOutData?.endDate || blockOutData?.date || "",
    );

    const startTimeStr = isAllDay
      ? "00:00"
      : String(blockOutData?.startTime || "00:00");
    const endTimeStr = isAllDay
      ? "23:59"
      : String(blockOutData?.endTime || "23:59");

    const selectedRooms: string[] = Array.isArray(blockOutData?.affectedRooms)
      ? blockOutData.affectedRooms
      : [];
    const selectedPharmacists: string[] = Array.isArray(
      blockOutData?.affectedPharmacists,
    )
      ? blockOutData.affectedPharmacists
      : [];
    const affectedPharmacistsForApi = selectedPharmacists.map(
      (pharmacist) =>
        pharmacistNameToId.get(
          String(pharmacist)
            .trim()
            .toLowerCase(),
        ) || pharmacist,
    );
    const affectedPharmacistsForLocal = selectedPharmacists.map(
      (pharmacist) => pharmacistIdToName.get(String(pharmacist)) || pharmacist,
    );

    const dateForCheck = String(
      blockOutData?.date || blockOutData?.startDate || startDateStr,
    );

    // 1) Check for existing appointments in the selected resources
    if (
      (selectedRooms.length > 0 || affectedPharmacistsForLocal.length > 0) &&
      hasEventConflictForBlockOut(
        dateForCheck,
        startTimeStr,
        endTimeStr,
        affectedPharmacistsForLocal,
        selectedRooms,
      )
    ) {
      throw new Error(
        "Cannot update block-out. There are existing appointments for the selected room or pharmacist in this time range.",
      );
    }

    // 2) Check for overlap with other block-outs
    if (
      hasBlockOutConflictForBlockOut(
        dateForCheck,
        startTimeStr,
        endTimeStr,
        affectedPharmacistsForLocal,
        selectedRooms,
        blockOutId,
      )
    ) {
      throw new Error(
        "Cannot update block-out. Another block-out exists for the selected room or pharmacist in this time range.",
      );
    }

    const buildLocalDateTimeString = (dateStr?: string, timeStr?: string) => {
      if (!dateStr) return null;

      // default time if missing
      const safeTime = timeStr || "00:00";

      const date = new Date(`${dateStr}T${safeTime}`);

      if (isNaN(date.getTime())) {
        throw new Error(`Invalid date/time: ${dateStr} ${safeTime}`);
      }

      return date.toISOString();
    };

    const startDateISO = buildLocalDateTimeString(startDateStr, startTimeStr);
    const endDateISO = buildLocalDateTimeString(endDateStr, endTimeStr);

    try {
      const targetPharmacyId =
        String(
          blockOutOtherPharmacyId ||
            otherPharmacyIdForBooking ||
            getBlockOutPharmacyId(blockOutId) ||
            currentPharmacyId,
        ).trim() || currentPharmacyId;

      // First, delete all existing block-outs with this ID
      await deleteBlockOut(blockOutId, targetPharmacyId);
      // Optimistically update UI
      const updatedLocal: BlockOut = {
        id: blockOutId,
        title: String(blockOutData?.title || ""),
        type: (blockOutData?.type || "other") as BlockOut["type"],
        startDate: startDateStr,
        endDate: endDateStr,
        startTime: startTimeStr,
        endTime: endTimeStr,
        description: String(blockOutData?.description || ""),
        affectedRooms: selectedRooms,
        affectedPharmacists: affectedPharmacistsForLocal,
        isRecurring: false,
        color: mapBlockOutTypeToColor(blockOutData?.type),
        otherPharmacyId: getBlockOutPharmacyId(blockOutId),
      };

      setLocalBlockOutUpdates((prev) => ({
        ...prev,
        [blockOutId]: updatedLocal,
      }));

      const payload = {
        id: blockOutId,
        title: blockOutData?.title || "",
        type: mapBlockOutTypeToEnum(blockOutData?.type),
        startDate: startDateISO,
        endDate: endDateISO,
        description: blockOutData?.description || "",
        affectedRooms: selectedRooms,
        affectedPharmacists: affectedPharmacistsForApi,
        color: mapBlockOutTypeToColor(blockOutData?.type),
      };
      // Use combined dispatcher to manage loading state through both API calls
      await addBlockOutAndRefresh(payload, targetPharmacyId);
      await refreshScheduleEventsSilently(currentPharmacyId);
      if (showMyAppointmentsOnly) {
        await refreshMyAppointmentsSilently();
      }
    } catch (e) {
      // On failure, remove optimistic update
      setLocalBlockOutUpdates((prev) => {
        const { [blockOutId]: _, ...rest } = prev;
        return rest;
      });
      console.error("Failed to update block-out:", e);
      throw e;
    }
  };
  const onDeleteBlockOut = async (
    blockOutId: string,
    blockOutOtherPharmacyId?: string,
  ) => {
    // Optimistically mark as deleted in UI
    setLocalBlockOutDeletes((prev) => new Set(prev).add(blockOutId));
    setLocalBlockOutAdds((prev) => prev.filter((b) => b.id !== blockOutId));
    setLocalBlockOutUpdates((prev) => {
      const { [blockOutId]: _, ...rest } = prev;
      return rest;
    });
    try {
      const targetPharmacyId =
        String(
          blockOutOtherPharmacyId ||
            otherPharmacyIdForBooking ||
            getBlockOutPharmacyId(blockOutId) ||
            currentPharmacyId,
        ).trim() || currentPharmacyId;

      await deleteBlockOut(blockOutId, targetPharmacyId);
      if (showMyAppointmentsOnly) {
        await refreshMyAppointmentsSilently();
      }
    } catch (e) {
      // Rollback optimistic deletion on failure
      setLocalBlockOutDeletes((prev) => {
        const copy = new Set(prev);
        copy.delete(blockOutId);
        return copy;
      });
      throw e;
    }
  };

  const validateBookingConflicts = (
    bookingData: any,
    excludeBookingId?: string,
  ) => {
    const {
      date,
      time,
      duration,
      pharmacist,
      room,
      confirmationMethod,
      mobile,
    } = bookingData;

    const resource = (resources || []).find(
      (r: any) => String(r.id) === String(pharmacist),
    );

    const pharmacistNameForCheck =
      resource?.name ||
      servicePharmacists.find((p: any) => String(p.id) === String(pharmacist))
        ?.name;

    if (confirmationMethod === "mobile") {
      if (!NumberIsUKFormat(mobile)) {
        return {
          isValid: false,
          message: "SMS delivery is available for UK mobile numbers only.",
        };
      }
    }
    // If updating, check if core fields have changed. If not, skip conflict checks.
    if (excludeBookingId) {
      const existing = mergedBookings.find((b) => b.id === excludeBookingId);
      if (existing) {
        const hasChanged =
          existing.date !== date ||
          existing.time !== time ||
          existing.duration !== parseInt(duration) ||
          normalizeName(existing.room || "") !== normalizeName(room || "") ||
          normalizeName(existing.pharmacist || "") !==
            normalizeName(pharmacistNameForCheck || "");

        if (!hasChanged) return { isValid: true, message: "" };
      }
    }

    if (isDateTimeInPast(date, time)) {
      return {
        isValid: false,
        message:
          "Cannot create appointments in the past. Please choose a future date and time.",
      };
    }

    if (
      hasBlockOutConflictForBooking(
        date,
        time,
        parseInt(duration),
        pharmacistNameForCheck,
        room,
      )
    ) {
      return {
        isValid: false,
        message:
          "Cannot create appointment. A block-out exists for the selected room or pharmacist in this time range.",
      };
    }

    if (
      room &&
      hasRoomConflict(date, time, parseInt(duration), room, excludeBookingId)
    ) {
      return {
        isValid: false,
        message:
          "Please select another room or different time slot. This slot for the selected room is already booked or unavailable.",
      };
    }

    if (
      pharmacistNameForCheck &&
      hasPharmacistConflict(
        date,
        time,
        parseInt(duration),
        pharmacistNameForCheck,
        excludeBookingId,
      )
    ) {
      return {
        isValid: false,
        message:
          "Please select another pharmacist or different time slot. This slot for the selected pharmacist is already booked or unavailable.",
      };
    }

    return { isValid: true, message: "" };
  };

  const matchesPharmacistHelper = (
    targetPharm?: string,
    pharmList?: string[],
  ): boolean => {
    if (!targetPharm || !pharmList || pharmList.length === 0) return false;

    const normTarget = normalizeName(targetPharm);
    const targetAliases = new Set<string>();
    targetAliases.add(normTarget);

    const matchedRes = (resources || []).find(
      (r: any) =>
        String(r.id || r._id).toLowerCase() === normTarget ||
        normalizeName(r.name) === normTarget,
    );
    if (matchedRes) {
      if (matchedRes.id) targetAliases.add(String(matchedRes.id).toLowerCase());
      if (matchedRes._id)
        targetAliases.add(String(matchedRes._id).toLowerCase());
      if (matchedRes.name) targetAliases.add(normalizeName(matchedRes.name));
    }

    return pharmList.some((boP) => {
      const normBoP = normalizeName(boP);
      if (targetAliases.has(normBoP)) return true;

      const boRes = (resources || []).find(
        (r: any) =>
          String(r.id || r._id).toLowerCase() === normBoP ||
          normalizeName(r.name) === normBoP,
      );
      if (boRes) {
        if (boRes.id && targetAliases.has(String(boRes.id).toLowerCase()))
          return true;
        if (boRes._id && targetAliases.has(String(boRes._id).toLowerCase()))
          return true;
        if (boRes.name && targetAliases.has(normalizeName(boRes.name)))
          return true;
      }
      return false;
    });
  };

  const matchesRoomHelper = (
    targetRoom?: string,
    roomList?: string[],
  ): boolean => {
    if (!targetRoom || !roomList || roomList.length === 0) return false;

    const normTarget = normalizeName(targetRoom);
    const targetAliases = new Set<string>();
    targetAliases.add(normTarget);

    const matchedRes = (resources || []).find(
      (r: any) =>
        String(r.id || r._id).toLowerCase() === normTarget ||
        normalizeName(r.name) === normTarget,
    );
    if (matchedRes) {
      if (matchedRes.id) targetAliases.add(String(matchedRes.id).toLowerCase());
      if (matchedRes._id)
        targetAliases.add(String(matchedRes._id).toLowerCase());
      if (matchedRes.name) targetAliases.add(normalizeName(matchedRes.name));
    }

    return roomList.some((boR) => {
      const normBoR = normalizeName(boR);
      if (targetAliases.has(normBoR)) return true;

      const boRes = (resources || []).find(
        (r: any) =>
          String(r.id || r._id).toLowerCase() === normBoR ||
          normalizeName(r.name) === normBoR,
      );
      if (boRes) {
        if (boRes.id && targetAliases.has(String(boRes.id).toLowerCase()))
          return true;
        if (boRes._id && targetAliases.has(String(boRes._id).toLowerCase()))
          return true;
        if (boRes.name && targetAliases.has(normalizeName(boRes.name)))
          return true;
      }
      return false;
    });
  };

  const validateBlockOutConflicts = (
    blockOutData: any,
    excludeBlockOutId?: string,
  ): ValidationResult => {
    const {
      startDate,
      endDate,
      startTime,
      endTime,
      isAllDay,
      affectedPharmacists = [],
      affectedRooms = [],
    } = blockOutData;

    const sDate = startDate || blockOutData.date || "";
    const eDate = endDate || startDate || blockOutData.date || "";
    const sTime = isAllDay ? "00:00" : startTime || "00:00";
    const eTime = isAllDay ? "23:59" : endTime || "23:59";

    if (!sDate || !sTime || !eTime) {
      return { isValid: true, message: "" };
    }

    const parseMins = (tStr?: string) => {
      if (!tStr) return 0;
      const parts = String(tStr).split(":");
      if (parts.length < 2) return 0;
      return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
    };

    const startMinutes = parseMins(sTime);
    const endMinutes = parseMins(eTime);

    const normPharmacists = (affectedPharmacists || []).map((p: string) =>
      normalizeName(p),
    );
    const normRooms = (affectedRooms || []).map((r: string) =>
      normalizeName(r),
    );

    // 1. Check against existing bookings
    for (const b of mergedBookings) {
      if (
        excludeBlockOutId &&
        (String(b.id) === String(excludeBlockOutId) ||
          String((b as any)._id) === String(excludeBlockOutId))
      ) {
        continue;
      }

      if (b.date >= sDate && b.date <= eDate) {
        let isResourceMatch = false;

        if (normPharmacists.length === 0 && normRooms.length === 0) {
          // Global blockout: affects all bookings
          isResourceMatch = true;
        } else if (normPharmacists.length > 0 && normRooms.length === 0) {
          // Pharmacists selected, no rooms selected
          isResourceMatch = matchesPharmacistHelper(
            b.pharmacist,
            normPharmacists,
          );
        } else if (normRooms.length > 0 && normPharmacists.length === 0) {
          // Rooms selected, no pharmacists selected
          isResourceMatch = matchesRoomHelper(b.room, normRooms);
        } else {
          // Both specified
          isResourceMatch =
            matchesPharmacistHelper(b.pharmacist, normPharmacists) ||
            matchesRoomHelper(b.room, normRooms);
        }

        if (isResourceMatch) {
          const bStartMins = parseMins(b.time);
          const bEndMins = bStartMins + Number(b.duration || 30);

          if (startMinutes < bEndMins && endMinutes > bStartMins) {
            const conflictName =
              b.pharmacist || b.patientName || "the selected resource";
            return {
              isValid: false,
              message: `Cannot create block-out. An appointment (${b.time}) already exists for ${conflictName} in this time slot.`,
            };
          }
        }
      }
    }

    // 2. Check against existing blockouts
    for (const bo of mergedBlockOuts) {
      if (
        excludeBlockOutId &&
        (String(bo.id) === String(excludeBlockOutId) ||
          String((bo as any)._id) === String(excludeBlockOutId))
      ) {
        continue;
      }

      const boStartDate =
        bo.startDate || bo.date || (bo as any).StartDate || "";
      const boEndDate =
        bo.endDate || bo.startDate || bo.date || (bo as any).EndDate || "";
      if (!boStartDate) continue;

      const dateOverlap = sDate <= boEndDate && eDate >= boStartDate;
      if (!dateOverlap) continue;

      const boPharmList = (bo.affectedPharmacists || []).map((p: string) =>
        normalizeName(p),
      );
      const boRoomList = (bo.affectedRooms || []).map((r: string) =>
        normalizeName(r),
      );

      const boIsGlobal = boPharmList.length === 0 && boRoomList.length === 0;
      const newIsGlobal =
        normPharmacists.length === 0 && normRooms.length === 0;

      let isResourceOverlap = false;

      if (boIsGlobal || newIsGlobal) {
        isResourceOverlap = true;
      } else {
        const pharmOverlap =
          normPharmacists.length > 0 &&
          boPharmList.length > 0 &&
          normPharmacists.some((p) => matchesPharmacistHelper(p, boPharmList));

        const roomOverlap =
          normRooms.length > 0 &&
          boRoomList.length > 0 &&
          normRooms.some((r) => matchesRoomHelper(r, boRoomList));

        isResourceOverlap = pharmOverlap || roomOverlap;
      }

      if (isResourceOverlap) {
        const boStartMins = parseMins(bo.startTime);
        const boEndMins = parseMins(bo.endTime);

        if (startMinutes < boEndMins && endMinutes > boStartMins) {
          return {
            isValid: false,
            message: `Cannot create block-out. A block-out (${bo.startTime} - ${bo.endTime}) already exists for the selected resource in this time range.`,
          };
        }
      }
    }

    return { isValid: true, message: "" };
  };

  // modal helpers
  const closeModal = () => {
    // Clear the "already fetched for this service" guard so reselecting the
    // same service in the next booking session re-fetches instead of being
    // silently skipped as a no-op duplicate call.
    resetServiceUsersFetchGuard();
    setModalState({ isOpen: false, mode: null });
  };

  const validatePharmacySlots = (data: any) => {
    const bookingDate = new Date(data.date);
    const jsDay = bookingDate.getDay();
    const apiDay = jsDay === 0 ? 7 : jsDay;

    const dayNames = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const dayName = dayNames[jsDay];

    const todayOpening = pharmacyOpeningHours.find(
      (x) => x.dayOfWeek === apiDay,
    );
    const parseMinutes = (t: string) => {
      if (!t) return NaN;
      const [h, m] = t.split(":").map(Number);
      return h * 60 + m;
    };
    const bookingStart = parseMinutes(data.time);
    const duration = Number(data.duration);
    const bookingEnd = bookingStart + duration;
    const endHH = String(Math.floor(bookingEnd / 60)).padStart(2, "0");
    const endMM = String(bookingEnd % 60).padStart(2, "0");
    const bookingEndTime = `${endHH}:${endMM}`;
    if (
      !todayOpening ||
      !todayOpening.slots ||
      todayOpening.slots.length === 0
    ) {
      return {
        isValid: false,
        message: `No slots available on ${dayName} (${data.date}).`,
      };
    }
    if (Number.isNaN(bookingStart) || Number.isNaN(duration) || duration <= 0) {
      return {
        isValid: false,
        message: `Invalid time or duration: time="${data.time}", duration="${data.duration}".`,
      };
    }
    const slotThatFits = todayOpening.slots.find((slot) => {
      const slotStart = parseMinutes(slot.startTime);
      const slotEnd = parseMinutes(slot.endTime);
      return bookingStart >= slotStart && bookingEnd <= slotEnd;
    });
    if (!slotThatFits) {
      const readableSlots = todayOpening.slots
        .map((s) => `${s.startTime}–${s.endTime}`)
        .join(", ");

      return {
        isValid: false,
        message:
          `The selected time ${data.time}–${bookingEndTime} on ${dayName} (${data.date}) is ` +
          `outside available slots: ${readableSlots}.`,
      };
    }
    const rooms = serviceRoomsByCompany;

    const selectedRoom = rooms.find((r: any) => r._id === data.room);

    if (!selectedRoom) {
      return {
        isValid: false,
        message: `Selected room not found.`,
      };
    }

    if (!selectedRoom.active) {
      return {
        isValid: false,
        message: `Selected room is not active.`,
      };
    }

    const roomDayAvailability = selectedRoom.availability?.find(
      (a: any) => a.dayOfWeek === apiDay,
    );

    if (!roomDayAvailability || !roomDayAvailability.slots?.length) {
      return {
        isValid: false,
        message: `Selected room is not available on ${dayName}.`,
      };
    }

    const fitsRoomSlot = roomDayAvailability.slots.some((slot: any) => {
      const slotStart = parseMinutes(slot.startTime);
      const slotEnd = parseMinutes(slot.endTime);
      return bookingStart >= slotStart && bookingEnd <= slotEnd;
    });

    if (!fitsRoomSlot) {
      const readableRoomSlots = roomDayAvailability.slots
        .map((s: any) => `${s.startTime}–${s.endTime}`)
        .join(", ");

      return {
        isValid: false,
        message:
          `Selected room is not available for ${data.time}–${bookingEndTime}. ` +
          `Available room slots: ${readableRoomSlots}.`,
      };
    }
    return { isValid: true, message: `` };
  };

  const onSaveFromModal = (data: any) => {
    if (modalState.isOpen && modalState.mode === "edit" && modalState.booking) {
      return onEditBooking(modalState.booking.id, data);
    } else {
      return onCreateBooking(data);
    }
  };

  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  // conflict warning UI state
  const [conflictWarning, setConflictWarning] = useState<string | null>(null);
  const clearConflictWarning = () => setConflictWarning(null);
  const lastClinicalServiceDetailsKeyRef = useRef<string | null>(null);
  const appointmentRoomsRequestKeyRef = useRef<string | null>(null);
  const lastUsersByServiceKeyRef = useRef<string | null>(null);
  const lastAvailableSlotsKeyRef = useRef<string | null>(null);
  const lastAvailableSlotsResponseRef = useRef<any>(null);
  const lastActivePharmacistsKeyRef = useRef<string | null>(null);

  // Lets a fresh booking-modal session re-fetch users/rooms for a service
  // even if it's the same service that was selected in a previous session
  // (the "already fetched" guard above is otherwise keyed only on
  // company/service/pharmacy, so it never sees this as a "change").
  const resetServiceUsersFetchGuard = useCallback(() => {
    lastUsersByServiceKeyRef.current = null;
    lastAvailableSlotsKeyRef.current = null;
    lastAvailableSlotsResponseRef.current = null;
    lastActivePharmacistsKeyRef.current = null;
  }, []);

  const onServiceTypeSelected = useCallback(
    async (data: any, overridePharmacyId?: string) => {
      try {
        if (typeof data === "string") {
          const serviceId = String(data).trim();
          if (!serviceId) return;

          const foundService = (defaultPharmacyServices || []).find(
            (s: any) =>
              s._id === serviceId ||
              s.serviceName?.trim().toLowerCase() ===
                String(serviceId)
                  .trim()
                  .toLowerCase(),
          );
          const actualServiceId = foundService ? foundService._id : serviceId;

          setSelectedServiceIdForRooms(actualServiceId);
          const targetPharmacyId =
            String(
              overridePharmacyId ||
                modalState?.booking?.otherPharmacyId ||
                (modalState?.booking as any)?.PharmacyID ||
                (modalState?.booking as any)?.OtherPharmacyId ||
                otherPharmacyIdForBooking ||
                "",
            ).trim() || currentPharmacyId;

          if (actualServiceId && companyId && targetPharmacyId) {
            const usersByServiceKey = `${companyId}:${actualServiceId}:${targetPharmacyId}`;
            if (lastUsersByServiceKeyRef.current !== usersByServiceKey) {
              lastUsersByServiceKeyRef.current = usersByServiceKey;
              if (ifNewCalendar) {
                await getAvailablePharmacistsForService(
                  companyId,
                  actualServiceId,
                  targetPharmacyId,
                );
              } else if (ifScheduleTabEnabled) {
                await getUsersByServiceCompanyPharmacyID(
                  companyId,
                  actualServiceId,
                  targetPharmacyId,
                );
              }
            }
            await getClinicalServicebyServiceCompanyId(
              companyId,
              actualServiceId,
            );
          }
          return;
        }

        const serviceId = String(
          data?.serviceType || data?.serviceId || "",
        ).trim();
        const duration = parseInt(String(data?.duration ?? 0), 10);
        console.log(
          "[Step 2] onServiceTypeSelected called - raw time slot from form",
          { rawDate: data?.date, rawTime: data?.time, serviceId, duration },
        );
        // data.date can be empty when a service is selected before a date is
        // picked - new Date("").toISOString() throws, which used to abort
        // this whole function (including the users/active-pharmacists
        // fetches below) before it even got started.
        const parsedDate = data?.date ? new Date(data.date) : null;
        const appointmentDate =
          parsedDate && !isNaN(parsedDate.getTime())
            ? parsedDate.toISOString()
            : "";
        // Slots the caller knows every pharmacist is booked at are never used as startTime.
        const isSlotUnavailable: (time: string) => boolean =
          typeof data?.isSlotUnavailable === "function"
            ? data.isSlotUnavailable
            : () => false;
        const rawSelectedStartTime = String(data?.time || "").trim();
        const selectedStartTime =
          rawSelectedStartTime &&
          (data?.eventId ||
            data?.appointmentId ||
            !isSlotUnavailable(rawSelectedStartTime))
            ? rawSelectedStartTime
            : "";
        const skipAvailableSlots = Boolean(data?.skipAvailableSlots);
        const skipUsersAndClinicalFetch = Boolean(
          data?.skipUsersAndClinicalFetch,
        );

        if (!serviceId) return;

        const foundService = (defaultPharmacyServices || []).find(
          (s: any) =>
            s._id === serviceId ||
            s.serviceName?.trim().toLowerCase() ===
              String(serviceId)
                .trim()
                .toLowerCase(),
        );
        const actualServiceId = foundService ? foundService._id : serviceId;
        setSelectedServiceIdForRooms(actualServiceId);
        const targetPharmacyId =
          String(
            data?.otherPharmacyId ||
              data?.PharmacyID ||
              data?.OtherPharmacyId ||
              modalState?.booking?.otherPharmacyId ||
              "",
          ).trim() || currentPharmacyId;

        if (
          !skipUsersAndClinicalFetch &&
          actualServiceId &&
          companyId &&
          targetPharmacyId
        ) {
          const usersByServiceKey = `${companyId}:${actualServiceId}:${targetPharmacyId}`;
          if (lastUsersByServiceKeyRef.current !== usersByServiceKey) {
            lastUsersByServiceKeyRef.current = usersByServiceKey;
            // await getUsersByServiceCompanyPharmacyID(
            //   companyId,
            //   actualServiceId,
            //   targetPharmacyId,
            // );
            await getAvailablePharmacistsForService(
              companyId,
              actualServiceId,
              targetPharmacyId,
            );
          }
        }

        const eventId =
          data?.eventId ||
          data?.appointmentId ||
          (modalState?.mode === "edit" && modalState?.booking?.id
            ? String(modalState.booking.id)
            : "");

        let availableSlotsResponse;
        if (
          !skipAvailableSlots &&
          targetPharmacyId &&
          appointmentDate &&
          duration > 0
        ) {
          const availableSlotsKey = `${targetPharmacyId}:${appointmentDate}:${duration}:${eventId ||
            ""}`;
          if (
            !data?.forceRefreshAvailability &&
            lastAvailableSlotsKeyRef.current === availableSlotsKey
          ) {
            // Same slot request as last time (e.g. an effect re-running on an
            // unrelated re-render) — reuse the cached result instead of
            // re-hitting the API.
            availableSlotsResponse = lastAvailableSlotsResponseRef.current;
          } else {
            availableSlotsResponse = await getPharmacyAvailableSlots({
              pharmacyId: targetPharmacyId,
              appointmentDate,
              duration,
              ...(eventId ? { eventId: eventId } : {}),
            });
            lastAvailableSlotsKeyRef.current = availableSlotsKey;
            lastAvailableSlotsResponseRef.current = availableSlotsResponse;
          }
        }

        const availableSlotsNormalized = Array.isArray(
          availableSlotsResponse?.pharmacyAvailableSlots,
        )
          ? availableSlotsResponse.pharmacyAvailableSlots.map((slot: any) =>
              String(slot || "").slice(0, 5),
            )
          : null;
        // Prefer a slot the Time dropdown actually lists, so startTime matches the
        // time shown in the form; fall back to the first usable slot otherwise.
        const isSlotSelectable: (time: string) => boolean =
          typeof data?.isSlotSelectable === "function"
            ? data.isSlotSelectable
            : () => true;
        const usableSlots = availableSlotsNormalized?.filter(
          (t: string) => !isSlotUnavailable(t),
        );
        const firstAvailableSlot =
          usableSlots?.find((t: string) => isSlotSelectable(t)) ||
          usableSlots?.[0] ||
          "";
        // If slots were freshly re-fetched (e.g. date changed) and the caller's
        // `time` is left over from a previous selection that's no longer valid
        // for this date, fall back to the first available slot instead of
        // sending a stale startTime to get-active-pharmacists.
        // When editing an existing event, its own already-booked slot is
        // always valid regardless of the general availability list (which can
        // come back empty if this slot isn't recognised as self-excluded) —
        // use it directly instead of falling through to an empty startTime.
        const startTime =
          eventId && selectedStartTime
            ? selectedStartTime
            : availableSlotsNormalized &&
              selectedStartTime &&
              !availableSlotsNormalized.includes(selectedStartTime)
            ? firstAvailableSlot
            : selectedStartTime || firstAvailableSlot;

        if (
          companyId &&
          targetPharmacyId &&
          actualServiceId &&
          appointmentDate &&
          duration > 0 &&
          startTime
        ) {
          const activePharmacistsKey = `${companyId}:${targetPharmacyId}:${actualServiceId}:${appointmentDate}:${duration}:${startTime}:${eventId ||
            ""}`;
          if (
            data?.forceRefreshAvailability ||
            lastActivePharmacistsKeyRef.current !== activePharmacistsKey
          ) {
            lastActivePharmacistsKeyRef.current = activePharmacistsKey;

            await getActivePharmacists({
              companyId,
              pharmacyId: targetPharmacyId,
              serviceId: actualServiceId,
              appointmentDate,
              duration,
              startTime,
              ...(eventId ? { eventId: eventId } : {}),
            });
            setActivePharmacistsRequest({
              serviceId: actualServiceId,
              date: appointmentDate.slice(0, 10),
              duration,
              startTime,
            });
          }
        }

        const clinicalServiceDetailsKey = `${companyId ||
          ""}:${actualServiceId || ""}`;
        if (
          actualServiceId &&
          companyId &&
          lastClinicalServiceDetailsKeyRef.current !== clinicalServiceDetailsKey
        ) {
          lastClinicalServiceDetailsKeyRef.current = clinicalServiceDetailsKey;
          try {
            await getClinicalServicebyServiceCompanyId(
              companyId,
              actualServiceId,
            );
          } catch (error) {
            lastClinicalServiceDetailsKeyRef.current = null;
            throw error;
          }
        }

        return availableSlotsResponse;
      } catch (e) {
        console.error(e);
      }
    },
    [
      companyId,
      modalState?.booking?.id,
      modalState?.booking?.otherPharmacyId,
      (modalState?.booking as any)?.PharmacyID,
      (modalState?.booking as any)?.OtherPharmacyId,
      otherPharmacyIdForBooking,
      modalState?.mode,
      currentPharmacyId,
      defaultPharmacyServices,
    ],
  );

  const onPharmacistSelected = useCallback(
    async (
      serviceId: string,
      pharmacistResourceId: string,
      overridePharmacyId?: string,
      loadLegacyAvailability = true,
    ) => {
      try {
        if (!serviceId || !pharmacistResourceId || !loadLegacyAvailability) {
          return;
        }
        const targetPharmacyId =
          String(
            overridePharmacyId ||
              modalState?.booking?.otherPharmacyId ||
              (modalState?.booking as any)?.PharmacyID ||
              (modalState?.booking as any)?.OtherPharmacyId ||
              otherPharmacyIdForBooking ||
              "",
          ).trim() || currentPharmacyId;
        await getUsrAvailibility(
          pharmacistResourceId,
          serviceId,
          targetPharmacyId,
        );
      } catch (e) {
        console.error(e);
      }
    },
    [
      modalState?.booking?.id,
      modalState?.booking?.otherPharmacyId,
      (modalState?.booking as any)?.PharmacyID,
      (modalState?.booking as any)?.OtherPharmacyId,
      otherPharmacyIdForBooking,
      currentPharmacyId,
    ],
  );

  const onAnyPharmacistSelected = useCallback(
    async (serviceId: string, overridePharmacyId?: string) => {
      try {
        if (!serviceId || !companyId) return;
        const targetPharmacyId =
          String(
            overridePharmacyId ||
              modalState?.booking?.otherPharmacyId ||
              (modalState?.booking as any)?.PharmacyID ||
              (modalState?.booking as any)?.OtherPharmacyId ||
              otherPharmacyIdForBooking ||
              "",
          ).trim() || currentPharmacyId;
        await getUsersAvailabilityByPriority(
          companyId,
          serviceId,
          targetPharmacyId,
        );
      } catch (e) {
        console.error(e);
      }
    },
    [
      companyId,
      modalState?.booking?.id,
      modalState?.booking?.otherPharmacyId,
      (modalState?.booking as any)?.PharmacyID,
      (modalState?.booking as any)?.OtherPharmacyId,
      otherPharmacyIdForBooking,
      currentPharmacyId,
    ],
  );

  const handleStartConsultation = async (b: any) => {
    const consultationCheckModel = {
      consultationID: b?.consultationID,
      patientId: b?.patientId || b?.patientID,
      id: b?.id,
    };

    await checkAndAddConsultation(consultationCheckModel);
    await getPatientConsultationByConsultationId(b?.consultationID);
    const pid = b?.patientId || b?.patientID;
    const consultationID = b?.consultationID || b?.id;
    const targetPharmacyId =
      String(b?.otherPharmacyId || "").trim() || currentPharmacyId;
    if (pid && targetPharmacyId && consultationID) {
      await getPatientByPatientId(pid);
      setRoutedFromScheduler(true);
      setCurrentGlobalTabValue(ifPharmacyDashboardEnabled ? 4 : 3);
      setCurrentGlobalTabText("Patients");
      closeModal();
      setisPatientSearched(true);
      setPatientInfoTab(1);
      setShowNHS111ReferralTab(false);
      setIsTemplateSelected(true);
      const patientConsultation = await getPatientConsultations(pid);
      const consultationRes = await getPatientConsultationByConsultationId(
        consultationID,
      );
      setPatientTabSwitcher(consultationRes?.preConsultationTemplate ? 1 : 0);
      if (consultationRes?.consultationChat) {
        try {
          const parsedAiChatMessages = JSON.parse(
            consultationRes.consultationChat,
          );
          setAiChatSuccessMessages();
          parsedAiChatMessages.forEach((message) => {
            setAddPatientAIChatMessage(message);
          });
        } catch (err) {
          console.error("Invalid consultationChat JSON:", err);
        }
      }
      await getPaymentAuditByConsultation({ consultationID: consultationID });
      if (consultationRes?.preConsultationTemplate) {
        const preConsultDataRes = await getPreConsultationByConsultationId({
          consultationId: consultationRes?.consultationId,
        });

        setPreConsultationTemplate(preConsultDataRes?.preConsultationTemplate);

        if (preConsultDataRes?.preConsultationTemplate) {
          let preConsultTranscription = "";

          preConsultDataRes.preConsultationTemplate.templateSections?.forEach(
            (section) => {
              section?.userControls?.forEach((control) => {
                if (control.label && control.value) {
                  preConsultTranscription += ` ${control.label} ${control.value} `;
                }
              });
            },
          );

          setPreConsultationTranscription(preConsultTranscription.trim());
        } else {
          setPreConsultationTranscription("");
        }
      } else {
        setPreConsultationTemplate(null);
        setPreConsultationTranscription("");
      }
      const data = {
        consultationId: consultationCheckModel.consultationID,
        actionStatus: 2,
      };

      const eventData = {
        id: consultationCheckModel.id,
        eventStatus: 3,
      };

      await updateConsultationStatus(data);
      await updateEventStatus(eventData);

      routerNavigate(
        `/pharmacy/patientconsultation/${targetPharmacyId}/${pid}/${consultationID}`,
      );
    }
  };

  const handleGetAppointmentRooms = async (data: any) => {
    if (!data?.serviceType || !data?.date || !data?.time || !data?.duration) {
      setAppointmentRooms([]);
      appointmentRoomsRequestKeyRef.current = null;
      return null;
    }
    const targetPharmacyId =
      String(
        data?.otherPharmacyId ||
          data?.PharmacyID ||
          data?.OtherPharmacyId ||
          modalState?.booking?.otherPharmacyId ||
          (modalState?.booking as any)?.PharmacyID ||
          (modalState?.booking as any)?.OtherPharmacyId ||
          otherPharmacyIdForBooking ||
          "",
      ).trim() || currentPharmacyId;

    // `serviceType` may be an actual service id or (from some callers) the
    // service's display name — resolve it to the real id either way, same
    // as onServiceTypeSelected does, so the API never receives a name.
    const rawServiceId = String(data.serviceType).trim();
    const resolvedService = (defaultPharmacyServices || []).find(
      (s: any) =>
        s._id === rawServiceId ||
        s.serviceName?.trim().toLowerCase() === rawServiceId.toLowerCase(),
    );
    const actualServiceId = resolvedService
      ? resolvedService._id
      : rawServiceId;

    const payload = {
      serviceId: actualServiceId,
      pharmacyID: targetPharmacyId,
      appointmentDate: new Date(data.date).toISOString(),
      startTime: data.time,
      duration: Number(data.duration),
      ...(data?.eventId || data?.appointmentId
        ? { eventId: data.eventId || data.appointmentId }
        : {}),
      isNewAppointment:
        data.isNewAppointment !== undefined
          ? data.isNewAppointment
          : !(modalState.isOpen && modalState.mode === "edit"),
    };

    const requestKey = JSON.stringify(payload);
    // Same params as the last successful call — reuse what's already loaded
    // instead of re-hitting the API, but still hand callers the current data.
    if (appointmentRoomsRequestKeyRef.current === requestKey)
      return appointmentRooms;

    // Keep the key after success so back-to-back calls with the same
    // slot/service (e.g. multiple effects firing on modal open) don't
    // re-hit the API; a real param change produces a different key anyway.
    appointmentRoomsRequestKeyRef.current = requestKey;
    try {
      return await getRoomsForAppointment(payload);
    } catch (e) {
      appointmentRoomsRequestKeyRef.current = null;
      throw e;
    }
  };

  return {
    // theme
    isDarkMode,
    isEventsLoading,
    isEventCalendarLoading,
    isPatientDetailsLoading,

    // core state
    currentDate,
    view,
    calendarSelectedDate,
    modalState,

    // data
    pharmacists,
    pharmacistNames,
    rooms,
    roomNames,
    pharmacyRooms: roomInventory,
    serviceRooms,
    serviceDurations,
    serviceTypes,
    serviceTypesInfo,
    pharmacies,
    servicePharmacists,
    blockOutTypes,
    serviceColors: getServiceColors(isDarkMode),
    serviceColorsFromData,
    timeSlots: TIME_SLOTS,
    dayNames,
    currentPharmacyId,
    companyId,
    availableDates: schedulerAvailableDates,
    isPharmacistBookedAtSlot,
    activePharmacistsRequest,
    pharmacyAvailableSlotsDate,
    pharmacyAvailableSlotsCount: endpointAvailableTimes.length,
    getAvailableTimesForDate: getSchedulerAvailableTimesForDate,
    getAggregatedTimesForDate,
    getServiceAvailabilityWindowForDate,
    getServicePharmacistSlotsForDate,
    getServiceRoomSlotsForDate,
    getPharmacistWeekAvailabilitySlots,
    appointmentRooms,
    isAppointmentRoomsLoading,
    isScheduleEventsByPharmaciesLoading,

    // filters state
    selectedPharmacists,
    selectedServiceTypes,
    selectedPharmacies,
    selectedRooms,
    selectedBlockOutTypes,
    myAppointments,
    defaultPharmacyServices,
    bookingModalServices: calendarAppointmentServices,

    // filtered access
    getDaysInMonth,
    getWeekDays,
    getFilteredBookingsForDate,
    getFilteredBookingsForTimeSlot,
    getFilteredBlockOutsForDate,
    getFilteredBlockOutsForTimeSlot,

    // utils
    formatDate,
    formatDateFromDate,
    getViewTitle,

    // actions
    navigate,
    onCalendarSelect,
    handleViewDay,

    handleServiceTypeChange,
    handlePharmacistChange,
    handlePharmacyChange,
    handleSelectAllServices,
    handleSelectAllPharmacies,
    handleSelectAllPharmacists,
    handleRoomChange,
    handleSelectAllRooms,
    handleBlockOutTypeChange,
    handleSelectAllBlockOutTypes,
    handleStartConsultation,
    handleGetAppointmentRooms,

    onCreateBooking,
    onCreateBookingForDate,
    onShowEditBooking,
    onEditBooking,
    onDeleteBooking,

    onCreateBlockOut,
    onEditBlockOut,
    onDeleteBlockOut,

    openNewAppointment,

    // conflict warning state
    conflictWarning,
    clearConflictWarning,
    closeModal,
    validatePharmacySlots,
    validateBookingConflicts,
    validateBlockOutConflicts,
    onSaveFromModal,
    setView,
    selectedPatientConsultation,

    // service selection side-effect
    onServiceTypeSelected,
    resetServiceUsersFetchGuard,
    onPharmacistSelected,
    onAnyPharmacistSelected,
    showMyAppointmentsOnly,
    setShowMyAppointmentsOnly,
  };
}

// Context-aware hook: must be used within ScheduleProvider
export function useScheduleData(): UseScheduleDataReturn {
  const ctx = useContext(
    ScheduleContext as any,
  ) as UseScheduleDataReturn | null;
  if (!ctx) {
    throw new Error("useScheduleData must be used within a ScheduleProvider");
  }
  return ctx;
}
